import { jsx as Z, jsxs as he, Fragment as vt } from "react/jsx-runtime";
import { c as Me, I as ii } from "./Section-DOeCOW54.js";
import rt, { createContext as ki, useContext as ae, memo as oe, PureComponent as ne, useRef as we, useState as f, useEffect as a, Children as me, isValidElement as si, cloneElement as ri, useMemo as qe, createRef as ot, Fragment as Oi } from "react";
import { P as gt } from "./Picture-JvtjNict.js";
import { T as fe, u as Pi, I as Ei } from "./useMediaQuery-BZAMobKw.js";
import * as oi from "react-dom";
import { createPortal as at } from "react-dom";
import { M as Si } from "./Modal-DQnpXu98.js";
import { I as Di } from "./ImageCarousel-rVtFRbaH.js";
const Pe = {
  "icon-button": "elo-icon-button",
  "icon-button--rounded": "elo-icon-button--rounded",
  "icon-button--primary": "elo-icon-button--primary",
  "icon-button--secondary": "elo-icon-button--secondary",
  "icon-button--disabled": "elo-icon-button--disabled"
}, Tr = rt.forwardRef(
  ({ icon: t, isRounded: e = !1, variant: n, children: i, ...s }, r) => {
    const o = Me(Pe["icon-button"], s.className, {
      [Pe["icon-button--rounded"]]: e,
      [Pe["icon-button--primary"]]: n === "primary",
      [Pe["icon-button--secondary"]]: n === "secondary",
      [Pe["icon-button--disabled"]]: s.disabled
    });
    return /* @__PURE__ */ Z("button", { ...s, ref: r, className: o, children: /* @__PURE__ */ Z(ii, { name: t }) });
  }
), Ii = "elo-tag", _i = {
  tag: Ii
}, ai = rt.forwardRef(
  ({ children: t, className: e, ...n }, i) => {
    const s = Me(_i.tag, e);
    return /* @__PURE__ */ Z(
      fe,
      {
        ref: i,
        type: "label",
        size: "medium",
        extraClass: s,
        ...n,
        children: t
      }
    );
  }
), ji = "elo-spin", Ti = {
  "spinning-loader": "elo-spinning-loader",
  spin: ji
}, Br = () => /* @__PURE__ */ Z("div", { className: Ti["spinning-loader"], children: /* @__PURE__ */ Z(
  "svg",
  {
    width: "94",
    height: "94",
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ Z(
      "path",
      {
        d: "M10.3936 76.428L27.2033 60.3217C28.9457 62.9157 31.1861 65.1434 33.7778 66.8727L17.627 83.741C14.9328 81.5867 12.5168 79.1392 10.3936 76.428ZM2.22309 60.0726L23.6305 51.7337C24.2601 54.8553 25.4901 57.7571 27.2179 60.3071L6.00087 69.6426C4.41947 66.6382 3.14557 63.4433 2.22309 60.0726ZM0.74419 41.9439L23.5866 42.4422C23.2937 43.9224 23.1473 45.4465 23.1473 47C23.1473 48.5535 23.3084 50.1949 23.6159 51.719L0.758836 52.2173C0.583126 50.5027 0.49527 48.7587 0.49527 47C0.49527 45.2414 0.583122 43.6 0.74419 41.9439ZM5.91301 24.4894L27.1008 33.8248C25.4022 36.3895 24.1869 39.2913 23.5719 42.4129L2.16452 34.074C3.07236 30.7032 4.33161 27.4937 5.91301 24.4894ZM17.5392 10.3323L33.6753 27.2006C31.0836 28.9446 28.8579 31.1869 27.1301 33.7955L10.3058 17.6746C12.4289 14.9634 14.845 12.5013 17.5246 10.3323M33.8949 2.00803L42.2851 23.5954C39.1662 24.2256 36.267 25.4566 33.7192 27.1713L24.3333 5.83308C27.3058 4.23564 30.5125 2.94597 33.8949 2.00803ZM52.1249 0.527835L51.6271 23.5807C50.1335 23.2876 48.5814 23.1264 47 23.1264C45.4186 23.1264 43.8372 23.2876 42.329 23.5807L41.8312 0.527835C43.5151 0.351971 45.2429 0.264038 47 0.264038C48.7571 0.264038 50.441 0.35197 52.1249 0.513179M69.6374 5.80377L60.2662 27.142C57.7184 25.4273 54.8045 24.1963 51.6856 23.5807L60.0758 1.99337C63.4582 2.91666 66.6503 4.20633 69.6374 5.80377ZM83.6649 17.6453L66.8553 33.7662C65.1275 31.1722 62.8872 28.9299 60.2954 27.186L76.4315 10.3176C79.1258 12.472 81.5418 14.9341 83.6649 17.6453ZM91.8208 34.0593L70.4134 42.3982C69.7985 39.2766 68.5831 36.3602 66.8846 33.7955L88.0724 24.4747C89.6538 27.4791 90.913 30.6886 91.8208 34.0593ZM93.2412 52.232L70.3842 51.7337C70.6917 50.2095 70.8527 48.6268 70.8527 47C70.8527 45.3733 70.7063 43.9077 70.4134 42.4422L93.2558 41.9439C93.4169 43.6 93.5047 45.2853 93.5047 47C93.5047 48.7147 93.4169 50.5173 93.2412 52.232ZM87.9992 69.6572L66.7967 60.3217C68.5099 57.7717 69.7545 54.8699 70.3842 51.7484L91.7769 60.0873C90.8544 63.458 89.5805 66.6529 87.9992 69.6572ZM76.3437 83.7557L60.1929 66.8874C62.7847 65.158 65.025 62.9304 66.7821 60.3364L83.5917 76.4427C81.4686 79.1539 79.0379 81.6013 76.3437 83.7557ZM24.3919 88.2109L33.7778 66.8727C37.5702 69.4081 42.1094 70.8883 47.0146 70.8883C51.9199 70.8883 56.4298 69.4227 60.2222 66.902L69.5935 88.2402C66.621 89.8377 63.4143 91.1127 60.0319 92.036L51.6417 70.4486L52.1395 93.4869C50.4703 93.6481 48.7571 93.736 47.0293 93.736C45.3015 93.736 43.559 93.6481 41.8751 93.4722L42.373 70.4193L33.9828 92.0067C30.6004 91.0834 27.4083 89.7937 24.4358 88.1963",
        fill: "#FFD200"
      }
    )
  }
) }), Bi = "elo-desktop", ce = {
  "office-card": "elo-office-card",
  "office-card__image": "elo-office-card__image",
  "office-card__image-wrapper": "elo-office-card__image-wrapper",
  "office-card__tag": "elo-office-card__tag",
  "office-card__title": "elo-office-card__title",
  desktop: Bi,
  "office-card__square-feet": "elo-office-card__square-feet",
  "office-card__value": "elo-office-card__value",
  "office-card__div": "elo-office-card__div",
  "office-card__bottom": "elo-office-card__bottom",
  "office-card__top": "elo-office-card__top",
  "office-card__paragraph": "elo-office-card__paragraph"
}, Rr = rt.forwardRef(
  ({
    url: t,
    image: e,
    tagText: n,
    title: i,
    subtitle: s,
    squareFeet: r,
    // isFavourite,
    // onFavouriteClick,
    imageClassName: o,
    className: l,
    onClick: p,
    ...d
  }, u) => /* @__PURE__ */ he(
    "a",
    {
      ref: u,
      href: t,
      className: Me(ce["office-card"], l),
      onClick: p,
      ...d,
      children: [
        /* @__PURE__ */ Z(
          gt,
          {
            defaultSrc: e,
            alt: i,
            zoom: !0,
            className: Me(ce["office-card__image"], o),
            wrapperClassName: ce["office-card__image-wrapper"]
          }
        ),
        /* @__PURE__ */ Z(ai, { className: ce["office-card__tag"], children: n }),
        /* @__PURE__ */ he(
          "div",
          {
            className: `${ce["office-card__div"]} ${ce["office-card__top"]}`,
            children: [
              /* @__PURE__ */ Z(
                fe,
                {
                  type: "label",
                  size: "medium",
                  extraClass: ce["office-card__title"],
                  children: i
                }
              ),
              /* @__PURE__ */ he(
                fe,
                {
                  type: "label",
                  size: "medium",
                  extraClass: ce["office-card__square-feet"],
                  children: [
                    r,
                    " m²"
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ Z(
          "div",
          {
            className: `${ce["office-card__div"]} ${ce["office-card__bottom"]}`,
            children: /* @__PURE__ */ Z(
              fe,
              {
                type: "paragraph",
                size: "small",
                extraClass: ce["office-card__paragraph"],
                children: s
              }
            )
          }
        )
      ]
    }
  )
);
function _e(t) {
  "@babel/helpers - typeof";
  return _e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _e(t);
}
function Ri(t, e) {
  if (_e(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e || "default");
    if (_e(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Ui(t) {
  var e = Ri(t, "string");
  return _e(e) == "symbol" ? e : e + "";
}
function m(t, e, n) {
  return (e = Ui(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function li(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var lt, Zt;
function Ai() {
  if (Zt) return lt;
  Zt = 1;
  var t = process.env.NODE_ENV, e = function(i, s, r, o, l, p, d, u) {
    if (t !== "production" && s === void 0)
      throw new Error("invariant requires an error message argument");
    if (!i) {
      var h;
      if (s === void 0)
        h = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var g = [r, o, l, p, d, u], y = 0;
        h = new Error(s.replace(/%s/g, function() {
          return g[y++];
        })), h.name = "Invariant Violation";
      }
      throw h.framesToPop = 1, h;
    }
  };
  return lt = e, lt;
}
var zi = Ai(), re = /* @__PURE__ */ li(zi), A = ki(null);
function pi() {
  re(!!ae, "useGoogleMap is React hook and requires React version 16.8+");
  var t = ae(A);
  return re(!!t, "useGoogleMap needs a GoogleMap available up in the tree"), t;
}
function Zi(t, e, n) {
  return Object.keys(t).reduce(function(s, r) {
    return e(s, t[r], r);
  }, n);
}
function Ni(t, e) {
  Object.keys(t).forEach((n) => e(t[n], n));
}
function Vi(t, e, n, i) {
  var s = {}, r = (o, l) => {
    var p = n[l];
    p !== e[l] && (s[l] = p, o(i, p));
  };
  return Ni(t, r), s;
}
function $i(t, e, n) {
  var i = Zi(n, function(r, o, l) {
    return typeof t[l] == "function" && r.push(google.maps.event.addListener(e, o, t[l])), r;
  }, []);
  return i;
}
function Wi(t) {
  google.maps.event.removeListener(t);
}
function V() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  t.forEach(Wi);
}
function N(t) {
  var {
    updaterMap: e,
    eventMap: n,
    prevProps: i,
    nextProps: s,
    instance: r
  } = t, o = $i(s, r, n);
  return Vi(e, i, s, r), o;
}
var Nt = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseDown: "mousedown",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed"
}, Vt = {
  extraMapTypes(t, e) {
    e.forEach(function(i, s) {
      t.mapTypes.set(String(s), i);
    });
  },
  center(t, e) {
    t.setCenter(e);
  },
  clickableIcons(t, e) {
    t.setClickableIcons(e);
  },
  heading(t, e) {
    t.setHeading(e);
  },
  mapTypeId(t, e) {
    t.setMapTypeId(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  streetView(t, e) {
    t.setStreetView(e);
  },
  tilt(t, e) {
    t.setTilt(e);
  },
  zoom(t, e) {
    t.setZoom(e);
  }
};
function Fi(t) {
  var {
    children: e,
    options: n,
    id: i,
    mapContainerStyle: s,
    mapContainerClassName: r,
    center: o,
    // clickableIcons,
    // extraMapTypes,
    // heading,
    // mapTypeId,
    onClick: l,
    onDblClick: p,
    onDrag: d,
    onDragEnd: u,
    onDragStart: h,
    onMouseMove: g,
    onMouseOut: y,
    onMouseOver: c,
    onMouseDown: O,
    onMouseUp: w,
    onRightClick: P,
    // onMapTypeIdChanged,
    // onTilesLoaded,
    // onBoundsChanged,
    onCenterChanged: x,
    // onHeadingChanged,
    // onIdle,
    // onProjectionChanged,
    // onResize,
    // onTiltChanged,
    // onZoomChanged,
    onLoad: D,
    onUnmount: b
  } = t, [v, C] = f(null), k = we(null), [I, M] = f(null), [E, S] = f(null), [U, $] = f(null), [T, B] = f(null), [W, Y] = f(null), [F, q] = f(null), [H, J] = f(null), [Q, j] = f(null), [X, L] = f(null), [ie, te] = f(null), [z, se] = f(null), [_, G] = f(null);
  return a(() => {
    n && v !== null && v.setOptions(n);
  }, [v, n]), a(() => {
    v !== null && typeof o < "u" && v.setCenter(o);
  }, [v, o]), a(() => {
    v && p && (E !== null && google.maps.event.removeListener(E), S(google.maps.event.addListener(v, "dblclick", p)));
  }, [p]), a(() => {
    v && u && (U !== null && google.maps.event.removeListener(U), $(google.maps.event.addListener(v, "dragend", u)));
  }, [u]), a(() => {
    v && h && (T !== null && google.maps.event.removeListener(T), B(google.maps.event.addListener(v, "dragstart", h)));
  }, [h]), a(() => {
    v && O && (W !== null && google.maps.event.removeListener(W), Y(google.maps.event.addListener(v, "mousedown", O)));
  }, [O]), a(() => {
    v && g && (F !== null && google.maps.event.removeListener(F), q(google.maps.event.addListener(v, "mousemove", g)));
  }, [g]), a(() => {
    v && y && (H !== null && google.maps.event.removeListener(H), J(google.maps.event.addListener(v, "mouseout", y)));
  }, [y]), a(() => {
    v && c && (Q !== null && google.maps.event.removeListener(Q), j(google.maps.event.addListener(v, "mouseover", c)));
  }, [c]), a(() => {
    v && w && (X !== null && google.maps.event.removeListener(X), L(google.maps.event.addListener(v, "mouseup", w)));
  }, [w]), a(() => {
    v && P && (ie !== null && google.maps.event.removeListener(ie), te(google.maps.event.addListener(v, "rightclick", P)));
  }, [P]), a(() => {
    v && l && (z !== null && google.maps.event.removeListener(z), se(google.maps.event.addListener(v, "click", l)));
  }, [l]), a(() => {
    v && d && (_ !== null && google.maps.event.removeListener(_), G(google.maps.event.addListener(v, "drag", d)));
  }, [d]), a(() => {
    v && x && (I !== null && google.maps.event.removeListener(I), M(google.maps.event.addListener(v, "center_changed", x)));
  }, [l]), a(() => {
    var de = k.current === null ? null : new google.maps.Map(k.current, n);
    return C(de), de !== null && D && D(de), () => {
      de !== null && b && b(de);
    };
  }, []), Z("div", {
    id: i,
    ref: k,
    style: s,
    className: r,
    children: Z(A.Provider, {
      value: v,
      children: v !== null ? e : null
    })
  });
}
oe(Fi);
class Ur extends ne {
  constructor() {
    super(...arguments), m(this, "state", {
      map: null
    }), m(this, "registeredEvents", []), m(this, "mapRef", null), m(this, "getInstance", () => this.mapRef === null ? null : new google.maps.Map(this.mapRef, this.props.options)), m(this, "panTo", (e) => {
      var n = this.getInstance();
      n && n.panTo(e);
    }), m(this, "setMapCallback", () => {
      this.state.map !== null && this.props.onLoad && this.props.onLoad(this.state.map);
    }), m(this, "getRef", (e) => {
      this.mapRef = e;
    });
  }
  componentDidMount() {
    var e = this.getInstance();
    this.registeredEvents = N({
      updaterMap: Vt,
      eventMap: Nt,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        map: e
      };
    }, this.setMapCallback);
  }
  componentDidUpdate(e) {
    this.state.map !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Vt,
      eventMap: Nt,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.map
    }));
  }
  componentWillUnmount() {
    this.state.map !== null && (this.props.onUnmount && this.props.onUnmount(this.state.map), V(this.registeredEvents));
  }
  render() {
    return Z("div", {
      id: this.props.id,
      ref: this.getRef,
      style: this.props.mapContainerStyle,
      className: this.props.mapContainerClassName,
      children: Z(A.Provider, {
        value: this.state.map,
        children: this.state.map !== null ? this.props.children : null
      })
    });
  }
}
function $t(t, e, n, i, s, r, o) {
  try {
    var l = t[r](o), p = l.value;
  } catch (d) {
    return void n(d);
  }
  l.done ? e(p) : Promise.resolve(p).then(i, s);
}
function ui(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(i, s) {
      var r = t.apply(e, n);
      function o(p) {
        $t(r, i, s, o, l, "next", p);
      }
      function l(p) {
        $t(r, i, s, o, l, "throw", p);
      }
      o(void 0);
    });
  };
}
function di(t) {
  var {
    googleMapsApiKey: e,
    googleMapsClientId: n,
    version: i = "weekly",
    language: s,
    region: r,
    libraries: o,
    channel: l,
    mapIds: p,
    authReferrerPolicy: d
  } = t, u = [];
  return re(e && n || !(e && n), "You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time."), e ? u.push("key=".concat(e)) : n && u.push("client=".concat(n)), i && u.push("v=".concat(i)), s && u.push("language=".concat(s)), r && u.push("region=".concat(r)), o && o.length && u.push("libraries=".concat(o.sort().join(","))), l && u.push("channel=".concat(l)), p && p.length && u.push("map_ids=".concat(p.join(","))), d && u.push("auth_referrer_policy=".concat(d)), u.push("loading=async"), u.push("callback=initMap"), "https://maps.googleapis.com/maps/api/js?".concat(u.join("&"));
}
var be = typeof document < "u";
function ci(t) {
  var {
    url: e,
    id: n,
    nonce: i
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } = t;
  return be ? new Promise(function(r, o) {
    var l = document.getElementById(n), p = window;
    if (l) {
      var d = l.getAttribute("data-state");
      if (l.src === e && d !== "error") {
        if (d === "ready")
          return r(n);
        var u = p.initMap, h = l.onerror;
        p.initMap = function() {
          u && u(), r(n);
        }, l.onerror = function(y) {
          h && h(y), o(y);
        };
        return;
      } else
        l.remove();
    }
    var g = document.createElement("script");
    g.type = "text/javascript", g.src = e, g.id = n, g.async = !0, g.nonce = i || "", g.onerror = function(c) {
      g.setAttribute("data-state", "error"), o(c);
    }, p.initMap = function() {
      g.setAttribute("data-state", "ready"), r(n);
    }, document.head.appendChild(g);
  }).catch((s) => {
    throw console.error("injectScript error: ", s), s;
  }) : Promise.reject(new Error("document is undefined"));
}
function Wt(t) {
  var e = t.href;
  return e && (e.indexOf("https://fonts.googleapis.com/css?family=Roboto") === 0 || e.indexOf("https://fonts.googleapis.com/css?family=Google+Sans+Text") === 0) ? !0 : (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    t.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    t.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    t.styleSheet.cssText && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    t.styleSheet.cssText.replace(`\r
`, "").indexOf(".gm-style") === 0 ? (t.styleSheet.cssText = "", !0) : (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      t.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      t.innerHTML && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      t.innerHTML.replace(`\r
`, "").indexOf(".gm-style") === 0 ? (t.innerHTML = "", !0) : (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        t.tagName.toLowerCase() === "style" && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        !t.styleSheet && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        !t.innerHTML
      )
    )
  );
}
function gi() {
  var t = document.getElementsByTagName("head")[0];
  if (t) {
    var e = t.insertBefore.bind(t);
    t.insertBefore = function(s, r) {
      return Wt(s) || Reflect.apply(e, t, [s, r]), s;
    };
    var n = t.appendChild.bind(t);
    t.appendChild = function(s) {
      return Wt(s) || Reflect.apply(n, t, [s]), s;
    };
  }
}
var Ee = !1;
function hi() {
  return Z("div", {
    children: "Loading..."
  });
}
var ht = {
  id: "script-loader",
  version: "weekly"
};
class Hi extends ne {
  constructor() {
    super(...arguments), m(this, "check", ot()), m(this, "state", {
      loaded: !1
    }), m(this, "cleanupCallback", () => {
      delete window.google.maps, this.injectScript();
    }), m(this, "isCleaningUp", /* @__PURE__ */ ui(function* () {
      function e(n) {
        if (!Ee)
          n();
        else if (be)
          var i = window.setInterval(function() {
            Ee || (window.clearInterval(i), n());
          }, 1);
      }
      return new Promise(e);
    })), m(this, "cleanup", () => {
      Ee = !0;
      var e = document.getElementById(this.props.id);
      e && e.parentNode && e.parentNode.removeChild(e), Array.prototype.slice.call(document.getElementsByTagName("script")).filter(function(i) {
        return typeof i.src == "string" && i.src.includes("maps.googleapis");
      }).forEach(function(i) {
        i.parentNode && i.parentNode.removeChild(i);
      }), Array.prototype.slice.call(document.getElementsByTagName("link")).filter(function(i) {
        return i.href === "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans";
      }).forEach(function(i) {
        i.parentNode && i.parentNode.removeChild(i);
      }), Array.prototype.slice.call(document.getElementsByTagName("style")).filter(function(i) {
        return i.innerText !== void 0 && i.innerText.length > 0 && i.innerText.includes(".gm-");
      }).forEach(function(i) {
        i.parentNode && i.parentNode.removeChild(i);
      });
    }), m(this, "injectScript", () => {
      this.props.preventGoogleFontsLoading && gi(), re(!!this.props.id, 'LoadScript requires "id" prop to be a string: %s', this.props.id);
      var e = {
        id: this.props.id,
        nonce: this.props.nonce,
        url: di(this.props)
      };
      ci(e).then(() => {
        this.props.onLoad && this.props.onLoad(), this.setState(function() {
          return {
            loaded: !0
          };
        });
      }).catch((n) => {
        this.props.onError && this.props.onError(n), console.error(`
          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (`.concat(this.props.googleMapsApiKey || "-", ") or Client ID (").concat(this.props.googleMapsClientId || "-", `) to <LoadScript />
          Otherwise it is a Network issue.
        `));
      });
    });
  }
  componentDidMount() {
    if (be) {
      if (window.google && window.google.maps && !Ee) {
        console.error("google api is already presented");
        return;
      }
      this.isCleaningUp().then(this.injectScript).catch(function(n) {
        console.error("Error at injecting script after cleaning up: ", n);
      });
    }
  }
  componentDidUpdate(e) {
    this.props.libraries !== e.libraries && console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables"), be && e.language !== this.props.language && (this.cleanup(), this.setState(function() {
      return {
        loaded: !1
      };
    }, this.cleanupCallback));
  }
  componentWillUnmount() {
    if (be) {
      this.cleanup();
      var e = () => {
        this.check.current || (delete window.google, Ee = !1);
      };
      window.setTimeout(e, 1), this.props.onUnmount && this.props.onUnmount();
    }
  }
  render() {
    return he(vt, {
      children: [Z("div", {
        ref: this.check
      }), this.state.loaded ? this.props.children : this.props.loadingElement || Z(hi, {})]
    });
  }
}
m(Hi, "defaultProps", ht);
function Gi(t, e) {
  if (t == null) return {};
  var n = {};
  for (var i in t) if ({}.hasOwnProperty.call(t, i)) {
    if (e.includes(i)) continue;
    n[i] = t[i];
  }
  return n;
}
function yt(t, e) {
  if (t == null) return {};
  var n, i, s = Gi(t, e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    for (i = 0; i < r.length; i++) n = r[i], e.includes(n) || {}.propertyIsEnumerable.call(t, n) && (s[n] = t[n]);
  }
  return s;
}
var Ft;
function Ki(t) {
  var {
    id: e = ht.id,
    version: n = ht.version,
    nonce: i,
    googleMapsApiKey: s,
    googleMapsClientId: r,
    language: o,
    region: l,
    libraries: p,
    preventGoogleFontsLoading: d,
    channel: u,
    mapIds: h,
    authReferrerPolicy: g
  } = t, y = we(!1), [c, O] = f(!1), [w, P] = f(void 0);
  a(function() {
    return y.current = !0, () => {
      y.current = !1;
    };
  }, []), a(function() {
    be && d && gi();
  }, [d]), a(function() {
    c && re(!!window.google, "useLoadScript was marked as loaded, but window.google is not present. Something went wrong.");
  }, [c]);
  var x = di({
    version: n,
    googleMapsApiKey: s,
    googleMapsClientId: r,
    language: o,
    region: l,
    libraries: p,
    channel: u,
    mapIds: h,
    authReferrerPolicy: g
  });
  a(function() {
    if (!be)
      return;
    function v() {
      y.current && (O(!0), Ft = x);
    }
    if (window.google && window.google.maps && Ft === x) {
      v();
      return;
    }
    ci({
      id: e,
      url: x,
      nonce: i
    }).then(v).catch(function(k) {
      y.current && P(k), console.warn(`
        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (`.concat(s || "-", ") or Client ID (").concat(r || "-", `)
        Otherwise it is a Network issue.
      `)), console.error(k);
    });
  }, [e, x, i]);
  var D = we();
  return a(function() {
    D.current && p !== D.current && console.warn("Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables"), D.current = p;
  }, [p]), {
    isLoaded: c,
    loadError: w,
    url: x
  };
}
var qi = ["loadingElement", "onLoad", "onError", "onUnmount", "children"], Ji = Z(hi, {});
function Yi(t) {
  var {
    loadingElement: e,
    onLoad: n,
    onError: i,
    onUnmount: s,
    children: r
  } = t, o = yt(t, qi), {
    isLoaded: l,
    loadError: p
  } = Ki(o);
  return a(function() {
    l && typeof n == "function" && n();
  }, [l, n]), a(function() {
    p && typeof i == "function" && i(p);
  }, [p, i]), a(function() {
    return () => {
      s && s();
    };
  }, [s]), l ? r : e || Ji;
}
oe(Yi);
var Ht;
(function(t) {
  t[t.INITIALIZED = 0] = "INITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.SUCCESS = 2] = "SUCCESS", t[t.FAILURE = 3] = "FAILURE";
})(Ht || (Ht = {}));
function Gt(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Je(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Gt(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Gt(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var Kt = {}, qt = {
  options(t, e) {
    t.setOptions(e);
  }
};
function Qi(t) {
  var {
    options: e,
    onLoad: n,
    onUnmount: i
  } = t, s = ae(A), [r, o] = f(null);
  return a(() => {
    r !== null && r.setMap(s);
  }, [s]), a(() => {
    e && r !== null && r.setOptions(e);
  }, [r, e]), a(() => {
    var l = new google.maps.TrafficLayer(Je(Je({}, e), {}, {
      map: s
    }));
    return o(l), n && n(l), () => {
      r !== null && (i && i(r), r.setMap(null));
    };
  }, []), null;
}
oe(Qi);
class Xi extends ne {
  constructor() {
    super(...arguments), m(this, "state", {
      trafficLayer: null
    }), m(this, "setTrafficLayerCallback", () => {
      this.state.trafficLayer !== null && this.props.onLoad && this.props.onLoad(this.state.trafficLayer);
    }), m(this, "registeredEvents", []);
  }
  componentDidMount() {
    var e = new google.maps.TrafficLayer(Je(Je({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = N({
      updaterMap: qt,
      eventMap: Kt,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        trafficLayer: e
      };
    }, this.setTrafficLayerCallback);
  }
  componentDidUpdate(e) {
    this.state.trafficLayer !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: qt,
      eventMap: Kt,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.trafficLayer
    }));
  }
  componentWillUnmount() {
    this.state.trafficLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.trafficLayer), V(this.registeredEvents), this.state.trafficLayer.setMap(null));
  }
  render() {
    return null;
  }
}
m(Xi, "contextType", A);
function es(t) {
  var {
    onLoad: e,
    onUnmount: n
  } = t, i = ae(A), [s, r] = f(null);
  return a(() => {
    s !== null && s.setMap(i);
  }, [i]), a(() => {
    var o = new google.maps.BicyclingLayer();
    return r(o), o.setMap(i), e && e(o), () => {
      o !== null && (n && n(o), o.setMap(null));
    };
  }, []), null;
}
oe(es);
class ts extends ne {
  constructor() {
    super(...arguments), m(this, "state", {
      bicyclingLayer: null
    }), m(this, "setBicyclingLayerCallback", () => {
      this.state.bicyclingLayer !== null && (this.state.bicyclingLayer.setMap(this.context), this.props.onLoad && this.props.onLoad(this.state.bicyclingLayer));
    });
  }
  componentDidMount() {
    var e = new google.maps.BicyclingLayer();
    this.setState(() => ({
      bicyclingLayer: e
    }), this.setBicyclingLayerCallback);
  }
  componentWillUnmount() {
    this.state.bicyclingLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.bicyclingLayer), this.state.bicyclingLayer.setMap(null));
  }
  render() {
    return null;
  }
}
m(ts, "contextType", A);
function ns(t) {
  var {
    onLoad: e,
    onUnmount: n
  } = t, i = ae(A), [s, r] = f(null);
  return a(() => {
    s !== null && s.setMap(i);
  }, [i]), a(() => {
    var o = new google.maps.TransitLayer();
    return r(o), o.setMap(i), e && e(o), () => {
      s !== null && (n && n(s), s.setMap(null));
    };
  }, []), null;
}
oe(ns);
class is extends ne {
  constructor() {
    super(...arguments), m(this, "state", {
      transitLayer: null
    }), m(this, "setTransitLayerCallback", () => {
      this.state.transitLayer !== null && (this.state.transitLayer.setMap(this.context), this.props.onLoad && this.props.onLoad(this.state.transitLayer));
    });
  }
  componentDidMount() {
    var e = new google.maps.TransitLayer();
    this.setState(function() {
      return {
        transitLayer: e
      };
    }, this.setTransitLayerCallback);
  }
  componentWillUnmount() {
    this.state.transitLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.transitLayer), this.state.transitLayer.setMap(null));
  }
  render() {
    return null;
  }
}
m(is, "contextType", A);
function Jt(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Ye(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Jt(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Jt(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var Yt = {
  onCircleComplete: "circlecomplete",
  onMarkerComplete: "markercomplete",
  onOverlayComplete: "overlaycomplete",
  onPolygonComplete: "polygoncomplete",
  onPolylineComplete: "polylinecomplete",
  onRectangleComplete: "rectanglecomplete"
}, Qt = {
  drawingMode(t, e) {
    t.setDrawingMode(e);
  },
  options(t, e) {
    t.setOptions(e);
  }
};
function ss(t) {
  var {
    options: e,
    drawingMode: n,
    onCircleComplete: i,
    onMarkerComplete: s,
    onOverlayComplete: r,
    onPolygonComplete: o,
    onPolylineComplete: l,
    onRectangleComplete: p,
    onLoad: d,
    onUnmount: u
  } = t, h = ae(A), [g, y] = f(null), [c, O] = f(null), [w, P] = f(null), [x, D] = f(null), [b, v] = f(null), [C, k] = f(null), [I, M] = f(null);
  return a(() => {
    g !== null && g.setMap(h);
  }, [h]), a(() => {
    e && g !== null && g.setOptions(e);
  }, [g, e]), a(() => {
    g !== null && g.setDrawingMode(n ?? null);
  }, [g, n]), a(() => {
    g && i && (c !== null && google.maps.event.removeListener(c), O(google.maps.event.addListener(g, "circlecomplete", i)));
  }, [g, i]), a(() => {
    g && s && (w !== null && google.maps.event.removeListener(w), P(google.maps.event.addListener(g, "markercomplete", s)));
  }, [g, s]), a(() => {
    g && r && (x !== null && google.maps.event.removeListener(x), D(google.maps.event.addListener(g, "overlaycomplete", r)));
  }, [g, r]), a(() => {
    g && o && (b !== null && google.maps.event.removeListener(b), v(google.maps.event.addListener(g, "polygoncomplete", o)));
  }, [g, o]), a(() => {
    g && l && (C !== null && google.maps.event.removeListener(C), k(google.maps.event.addListener(g, "polylinecomplete", l)));
  }, [g, l]), a(() => {
    g && p && (I !== null && google.maps.event.removeListener(I), M(google.maps.event.addListener(g, "rectanglecomplete", p)));
  }, [g, p]), a(() => {
    re(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    var E = new google.maps.drawing.DrawingManager(Ye(Ye({}, e), {}, {
      map: h
    }));
    return n && E.setDrawingMode(n), i && O(google.maps.event.addListener(E, "circlecomplete", i)), s && P(google.maps.event.addListener(E, "markercomplete", s)), r && D(google.maps.event.addListener(E, "overlaycomplete", r)), o && v(google.maps.event.addListener(E, "polygoncomplete", o)), l && k(google.maps.event.addListener(E, "polylinecomplete", l)), p && M(google.maps.event.addListener(E, "rectanglecomplete", p)), y(E), d && d(E), () => {
      g !== null && (c && google.maps.event.removeListener(c), w && google.maps.event.removeListener(w), x && google.maps.event.removeListener(x), b && google.maps.event.removeListener(b), C && google.maps.event.removeListener(C), I && google.maps.event.removeListener(I), u && u(g), g.setMap(null));
    };
  }, []), null;
}
oe(ss);
class rs extends ne {
  constructor(e) {
    super(e), m(this, "registeredEvents", []), m(this, "state", {
      drawingManager: null
    }), m(this, "setDrawingManagerCallback", () => {
      this.state.drawingManager !== null && this.props.onLoad && this.props.onLoad(this.state.drawingManager);
    }), re(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
  }
  componentDidMount() {
    var e = new google.maps.drawing.DrawingManager(Ye(Ye({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = N({
      updaterMap: Qt,
      eventMap: Yt,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        drawingManager: e
      };
    }, this.setDrawingManagerCallback);
  }
  componentDidUpdate(e) {
    this.state.drawingManager !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Qt,
      eventMap: Yt,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.drawingManager
    }));
  }
  componentWillUnmount() {
    this.state.drawingManager !== null && (this.props.onUnmount && this.props.onUnmount(this.state.drawingManager), V(this.registeredEvents), this.state.drawingManager.setMap(null));
  }
  render() {
    return null;
  }
}
m(rs, "contextType", A);
function Xt(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Ce(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Xt(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Xt(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var en = {
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDraggableChanged: "draggable_changed",
  onDragStart: "dragstart",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onPositionChanged: "position_changed",
  onRightClick: "rightclick",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed"
}, tn = {
  animation(t, e) {
    t.setAnimation(e);
  },
  clickable(t, e) {
    t.setClickable(e);
  },
  cursor(t, e) {
    t.setCursor(e);
  },
  draggable(t, e) {
    t.setDraggable(e);
  },
  icon(t, e) {
    t.setIcon(e);
  },
  label(t, e) {
    t.setLabel(e);
  },
  map(t, e) {
    t.setMap(e);
  },
  opacity(t, e) {
    t.setOpacity(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  position(t, e) {
    t.setPosition(e);
  },
  shape(t, e) {
    t.setShape(e);
  },
  title(t, e) {
    t.setTitle(e);
  },
  visible(t, e) {
    t.setVisible(e);
  },
  zIndex(t, e) {
    t.setZIndex(e);
  }
}, Qe = {};
function os(t) {
  var {
    position: e,
    options: n,
    clusterer: i,
    noClustererRedraw: s,
    children: r,
    draggable: o,
    visible: l,
    animation: p,
    clickable: d,
    cursor: u,
    icon: h,
    label: g,
    opacity: y,
    shape: c,
    title: O,
    zIndex: w,
    onClick: P,
    onDblClick: x,
    onDrag: D,
    onDragEnd: b,
    onDragStart: v,
    onMouseOut: C,
    onMouseOver: k,
    onMouseUp: I,
    onMouseDown: M,
    onRightClick: E,
    onClickableChanged: S,
    onCursorChanged: U,
    onAnimationChanged: $,
    onDraggableChanged: T,
    onFlatChanged: B,
    onIconChanged: W,
    onPositionChanged: Y,
    onShapeChanged: F,
    onTitleChanged: q,
    onVisibleChanged: H,
    onZindexChanged: J,
    onLoad: Q,
    onUnmount: j
  } = t, X = ae(A), [L, ie] = f(null), [te, z] = f(null), [se, _] = f(null), [G, de] = f(null), [ge, ke] = f(null), [ee, Ct] = f(null), [je, Mt] = f(null), [Te, wt] = f(null), [Be, xt] = f(null), [Re, kt] = f(null), [Ot, Pt] = f(null), [Ue, Et] = f(null), [Ae, St] = f(null), [ze, Dt] = f(null), [Ze, It] = f(null), [Ne, _t] = f(null), [Ve, jt] = f(null), [$e, Tt] = f(null), [Bt, Rt] = f(null), [We, Ut] = f(null), [Fe, At] = f(null), [He, zt] = f(null);
  a(() => {
    L !== null && L.setMap(X);
  }, [X]), a(() => {
    typeof n < "u" && L !== null && L.setOptions(n);
  }, [L, n]), a(() => {
    typeof o < "u" && L !== null && L.setDraggable(o);
  }, [L, o]), a(() => {
    e && L !== null && L.setPosition(e);
  }, [L, e]), a(() => {
    typeof l < "u" && L !== null && L.setVisible(l);
  }, [L, l]), a(() => {
    L == null || L.setAnimation(p);
  }, [L, p]), a(() => {
    L && d !== void 0 && L.setClickable(d);
  }, [L, d]), a(() => {
    L && u !== void 0 && L.setCursor(u);
  }, [L, u]), a(() => {
    L && h !== void 0 && L.setIcon(h);
  }, [L, h]), a(() => {
    L && g !== void 0 && L.setLabel(g);
  }, [L, g]), a(() => {
    L && y !== void 0 && L.setOpacity(y);
  }, [L, y]), a(() => {
    L && c !== void 0 && L.setShape(c);
  }, [L, c]), a(() => {
    L && O !== void 0 && L.setTitle(O);
  }, [L, O]), a(() => {
    L && w !== void 0 && L.setZIndex(w);
  }, [L, w]), a(() => {
    L && x && (te !== null && google.maps.event.removeListener(te), z(google.maps.event.addListener(L, "dblclick", x)));
  }, [x]), a(() => {
    L && b && (se !== null && google.maps.event.removeListener(se), _(google.maps.event.addListener(L, "dragend", b)));
  }, [b]), a(() => {
    L && v && (G !== null && google.maps.event.removeListener(G), de(google.maps.event.addListener(L, "dragstart", v)));
  }, [v]), a(() => {
    L && M && (ge !== null && google.maps.event.removeListener(ge), ke(google.maps.event.addListener(L, "mousedown", M)));
  }, [M]), a(() => {
    L && C && (ee !== null && google.maps.event.removeListener(ee), Ct(google.maps.event.addListener(L, "mouseout", C)));
  }, [C]), a(() => {
    L && k && (je !== null && google.maps.event.removeListener(je), Mt(google.maps.event.addListener(L, "mouseover", k)));
  }, [k]), a(() => {
    L && I && (Te !== null && google.maps.event.removeListener(Te), wt(google.maps.event.addListener(L, "mouseup", I)));
  }, [I]), a(() => {
    L && E && (Be !== null && google.maps.event.removeListener(Be), xt(google.maps.event.addListener(L, "rightclick", E)));
  }, [E]), a(() => {
    L && P && (Re !== null && google.maps.event.removeListener(Re), kt(google.maps.event.addListener(L, "click", P)));
  }, [P]), a(() => {
    L && D && (Ot !== null && google.maps.event.removeListener(Ot), Pt(google.maps.event.addListener(L, "drag", D)));
  }, [D]), a(() => {
    L && S && (Ue !== null && google.maps.event.removeListener(Ue), Et(google.maps.event.addListener(L, "clickable_changed", S)));
  }, [S]), a(() => {
    L && U && (Ae !== null && google.maps.event.removeListener(Ae), St(google.maps.event.addListener(L, "cursor_changed", U)));
  }, [U]), a(() => {
    L && $ && (ze !== null && google.maps.event.removeListener(ze), Dt(google.maps.event.addListener(L, "animation_changed", $)));
  }, [$]), a(() => {
    L && T && (Ze !== null && google.maps.event.removeListener(Ze), It(google.maps.event.addListener(L, "draggable_changed", T)));
  }, [T]), a(() => {
    L && B && (Ne !== null && google.maps.event.removeListener(Ne), _t(google.maps.event.addListener(L, "flat_changed", B)));
  }, [B]), a(() => {
    L && W && (Ve !== null && google.maps.event.removeListener(Ve), jt(google.maps.event.addListener(L, "icon_changed", W)));
  }, [W]), a(() => {
    L && Y && ($e !== null && google.maps.event.removeListener($e), Tt(google.maps.event.addListener(L, "position_changed", Y)));
  }, [Y]), a(() => {
    L && F && (Bt !== null && google.maps.event.removeListener(Bt), Rt(google.maps.event.addListener(L, "shape_changed", F)));
  }, [F]), a(() => {
    L && q && (We !== null && google.maps.event.removeListener(We), Ut(google.maps.event.addListener(L, "title_changed", q)));
  }, [q]), a(() => {
    L && H && (Fe !== null && google.maps.event.removeListener(Fe), At(google.maps.event.addListener(L, "visible_changed", H)));
  }, [H]), a(() => {
    L && J && (He !== null && google.maps.event.removeListener(He), zt(google.maps.event.addListener(L, "zindex_changed", J)));
  }, [J]), a(() => {
    var Oe = Ce(Ce(Ce({}, n || Qe), i ? Qe : {
      map: X
    }), {}, {
      position: e
    }), R = new google.maps.Marker(Oe);
    return i ? i.addMarker(R, !!s) : R.setMap(X), e && R.setPosition(e), typeof l < "u" && R.setVisible(l), typeof o < "u" && R.setDraggable(o), typeof d < "u" && R.setClickable(d), typeof u == "string" && R.setCursor(u), h && R.setIcon(h), typeof g < "u" && R.setLabel(g), typeof y < "u" && R.setOpacity(y), c && R.setShape(c), typeof O == "string" && R.setTitle(O), typeof w == "number" && R.setZIndex(w), x && z(google.maps.event.addListener(R, "dblclick", x)), b && _(google.maps.event.addListener(R, "dragend", b)), v && de(google.maps.event.addListener(R, "dragstart", v)), M && ke(google.maps.event.addListener(R, "mousedown", M)), C && Ct(google.maps.event.addListener(R, "mouseout", C)), k && Mt(google.maps.event.addListener(R, "mouseover", k)), I && wt(google.maps.event.addListener(R, "mouseup", I)), E && xt(google.maps.event.addListener(R, "rightclick", E)), P && kt(google.maps.event.addListener(R, "click", P)), D && Pt(google.maps.event.addListener(R, "drag", D)), S && Et(google.maps.event.addListener(R, "clickable_changed", S)), U && St(google.maps.event.addListener(R, "cursor_changed", U)), $ && Dt(google.maps.event.addListener(R, "animation_changed", $)), T && It(google.maps.event.addListener(R, "draggable_changed", T)), B && _t(google.maps.event.addListener(R, "flat_changed", B)), W && jt(google.maps.event.addListener(R, "icon_changed", W)), Y && Tt(google.maps.event.addListener(R, "position_changed", Y)), F && Rt(google.maps.event.addListener(R, "shape_changed", F)), q && Ut(google.maps.event.addListener(R, "title_changed", q)), H && At(google.maps.event.addListener(R, "visible_changed", H)), J && zt(google.maps.event.addListener(R, "zindex_changed", J)), ie(R), Q && Q(R), () => {
      te !== null && google.maps.event.removeListener(te), se !== null && google.maps.event.removeListener(se), G !== null && google.maps.event.removeListener(G), ge !== null && google.maps.event.removeListener(ge), ee !== null && google.maps.event.removeListener(ee), je !== null && google.maps.event.removeListener(je), Te !== null && google.maps.event.removeListener(Te), Be !== null && google.maps.event.removeListener(Be), Re !== null && google.maps.event.removeListener(Re), Ue !== null && google.maps.event.removeListener(Ue), Ae !== null && google.maps.event.removeListener(Ae), ze !== null && google.maps.event.removeListener(ze), Ze !== null && google.maps.event.removeListener(Ze), Ne !== null && google.maps.event.removeListener(Ne), Ve !== null && google.maps.event.removeListener(Ve), $e !== null && google.maps.event.removeListener($e), We !== null && google.maps.event.removeListener(We), Fe !== null && google.maps.event.removeListener(Fe), He !== null && google.maps.event.removeListener(He), j && j(R), i ? i.removeMarker(R, !!s) : R && R.setMap(null);
    };
  }, []);
  var xi = qe(() => r ? me.map(r, (Oe) => {
    if (!si(Oe))
      return Oe;
    var R = Oe;
    return ri(R, {
      anchor: L
    });
  }) : null, [r, L]);
  return Z(vt, {
    children: xi
  }) || null;
}
oe(os);
class as extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []);
  }
  componentDidMount() {
    var e = this;
    return ui(function* () {
      var n = Ce(Ce(Ce({}, e.props.options || Qe), e.props.clusterer ? Qe : {
        map: e.context
      }), {}, {
        position: e.props.position
      });
      e.marker = new google.maps.Marker(n), e.props.clusterer ? e.props.clusterer.addMarker(e.marker, !!e.props.noClustererRedraw) : e.marker.setMap(e.context), e.registeredEvents = N({
        updaterMap: tn,
        eventMap: en,
        prevProps: {},
        nextProps: e.props,
        instance: e.marker
      }), e.props.onLoad && e.props.onLoad(e.marker);
    })();
  }
  componentDidUpdate(e) {
    this.marker && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: tn,
      eventMap: en,
      prevProps: e,
      nextProps: this.props,
      instance: this.marker
    }));
  }
  componentWillUnmount() {
    this.marker && (this.props.onUnmount && this.props.onUnmount(this.marker), V(this.registeredEvents), this.props.clusterer ? this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw) : this.marker && this.marker.setMap(null));
  }
  render() {
    var e = this.props.children ? me.map(this.props.children, (n) => {
      if (!si(n))
        return n;
      var i = n;
      return ri(i, {
        anchor: this.marker
      });
    }) : null;
    return e || null;
  }
}
m(as, "contextType", A);
var ls = (
  /** @class */
  function() {
    function t(e, n) {
      e.getClusterer().extend(t, google.maps.OverlayView), this.cluster = e, this.clusterClassName = this.cluster.getClusterer().getClusterClass(), this.className = this.clusterClassName, this.styles = n, this.center = void 0, this.div = null, this.sums = null, this.visible = !1, this.boundsChangedListener = null, this.url = "", this.height = 0, this.width = 0, this.anchorText = [0, 0], this.anchorIcon = [0, 0], this.textColor = "black", this.textSize = 11, this.textDecoration = "none", this.fontWeight = "bold", this.fontStyle = "normal", this.fontFamily = "Arial,sans-serif", this.backgroundPosition = "0 0", this.cMouseDownInCluster = null, this.cDraggingMapByCluster = null, this.timeOut = null, this.setMap(e.getMap()), this.onBoundsChanged = this.onBoundsChanged.bind(this), this.onMouseDown = this.onMouseDown.bind(this), this.onClick = this.onClick.bind(this), this.onMouseOver = this.onMouseOver.bind(this), this.onMouseOut = this.onMouseOut.bind(this), this.onAdd = this.onAdd.bind(this), this.onRemove = this.onRemove.bind(this), this.draw = this.draw.bind(this), this.hide = this.hide.bind(this), this.show = this.show.bind(this), this.useStyle = this.useStyle.bind(this), this.setCenter = this.setCenter.bind(this), this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
    }
    return t.prototype.onBoundsChanged = function() {
      this.cDraggingMapByCluster = this.cMouseDownInCluster;
    }, t.prototype.onMouseDown = function() {
      this.cMouseDownInCluster = !0, this.cDraggingMapByCluster = !1;
    }, t.prototype.onClick = function(e) {
      if (this.cMouseDownInCluster = !1, !this.cDraggingMapByCluster) {
        var n = this.cluster.getClusterer();
        if (google.maps.event.trigger(n, "click", this.cluster), google.maps.event.trigger(n, "clusterclick", this.cluster), n.getZoomOnClick()) {
          var i = n.getMaxZoom(), s = this.cluster.getBounds(), r = n.getMap();
          r !== null && "fitBounds" in r && r.fitBounds(s), this.timeOut = window.setTimeout(function() {
            var o = n.getMap();
            if (o !== null) {
              "fitBounds" in o && o.fitBounds(s);
              var l = o.getZoom() || 0;
              i !== null && l > i && o.setZoom(i + 1);
            }
          }, 100);
        }
        e.cancelBubble = !0, e.stopPropagation && e.stopPropagation();
      }
    }, t.prototype.onMouseOver = function() {
      google.maps.event.trigger(this.cluster.getClusterer(), "mouseover", this.cluster);
    }, t.prototype.onMouseOut = function() {
      google.maps.event.trigger(this.cluster.getClusterer(), "mouseout", this.cluster);
    }, t.prototype.onAdd = function() {
      var e;
      this.div = document.createElement("div"), this.div.className = this.className, this.visible && this.show(), (e = this.getPanes()) === null || e === void 0 || e.overlayMouseTarget.appendChild(this.div);
      var n = this.getMap();
      n !== null && (this.boundsChangedListener = google.maps.event.addListener(n, "bounds_changed", this.onBoundsChanged), this.div.addEventListener("mousedown", this.onMouseDown), this.div.addEventListener("click", this.onClick), this.div.addEventListener("mouseover", this.onMouseOver), this.div.addEventListener("mouseout", this.onMouseOut));
    }, t.prototype.onRemove = function() {
      this.div && this.div.parentNode && (this.hide(), this.boundsChangedListener !== null && google.maps.event.removeListener(this.boundsChangedListener), this.div.removeEventListener("mousedown", this.onMouseDown), this.div.removeEventListener("click", this.onClick), this.div.removeEventListener("mouseover", this.onMouseOver), this.div.removeEventListener("mouseout", this.onMouseOut), this.div.parentNode.removeChild(this.div), this.timeOut !== null && (window.clearTimeout(this.timeOut), this.timeOut = null), this.div = null);
    }, t.prototype.draw = function() {
      if (this.visible && this.div !== null && this.center) {
        var e = this.getPosFromLatLng(this.center);
        this.div.style.top = e !== null ? "".concat(e.y, "px") : "0", this.div.style.left = e !== null ? "".concat(e.x, "px") : "0";
      }
    }, t.prototype.hide = function() {
      this.div && (this.div.style.display = "none"), this.visible = !1;
    }, t.prototype.show = function() {
      var e, n, i, s, r, o;
      if (this.div && this.center) {
        var l = this.sums === null || typeof this.sums.title > "u" || this.sums.title === "" ? this.cluster.getClusterer().getTitle() : this.sums.title, p = this.backgroundPosition.split(" "), d = parseInt(((e = p[0]) === null || e === void 0 ? void 0 : e.replace(/^\s+|\s+$/g, "")) || "0", 10), u = parseInt(((n = p[1]) === null || n === void 0 ? void 0 : n.replace(/^\s+|\s+$/g, "")) || "0", 10), h = this.getPosFromLatLng(this.center);
        this.div.className = this.className, this.div.setAttribute("style", "cursor: pointer; position: absolute; top: ".concat(h !== null ? "".concat(h.y, "px") : "0", "; left: ").concat(h !== null ? "".concat(h.x, "px") : "0", "; width: ").concat(this.width, "px; height: ").concat(this.height, "px; "));
        var g = document.createElement("img");
        g.alt = l, g.src = this.url, g.width = this.width, g.height = this.height, g.setAttribute("style", "position: absolute; top: ".concat(u, "px; left: ").concat(d, "px")), this.cluster.getClusterer().enableRetinaIcons || (g.style.clip = "rect(-".concat(u, "px, -").concat(d + this.width, "px, -").concat(u + this.height, ", -").concat(d, ")"));
        var y = document.createElement("div");
        y.setAttribute("style", "position: absolute; top: ".concat(this.anchorText[0], "px; left: ").concat(this.anchorText[1], "px; color: ").concat(this.textColor, "; font-size: ").concat(this.textSize, "px; font-family: ").concat(this.fontFamily, "; font-weight: ").concat(this.fontWeight, "; fontStyle: ").concat(this.fontStyle, "; text-decoration: ").concat(this.textDecoration, "; text-align: center; width: ").concat(this.width, "px; line-height: ").concat(this.height, "px")), !((i = this.sums) === null || i === void 0) && i.text && (y.innerText = "".concat((s = this.sums) === null || s === void 0 ? void 0 : s.text)), !((r = this.sums) === null || r === void 0) && r.html && (y.innerHTML = "".concat((o = this.sums) === null || o === void 0 ? void 0 : o.html)), this.div.innerHTML = "", this.div.appendChild(g), this.div.appendChild(y), this.div.title = l, this.div.style.display = "";
      }
      this.visible = !0;
    }, t.prototype.useStyle = function(e) {
      this.sums = e;
      var n = this.cluster.getClusterer().getStyles(), i = n[Math.min(n.length - 1, Math.max(0, e.index - 1))];
      i && (this.url = i.url, this.height = i.height, this.width = i.width, i.className && (this.className = "".concat(this.clusterClassName, " ").concat(i.className)), this.anchorText = i.anchorText || [0, 0], this.anchorIcon = i.anchorIcon || [this.height / 2, this.width / 2], this.textColor = i.textColor || "black", this.textSize = i.textSize || 11, this.textDecoration = i.textDecoration || "none", this.fontWeight = i.fontWeight || "bold", this.fontStyle = i.fontStyle || "normal", this.fontFamily = i.fontFamily || "Arial,sans-serif", this.backgroundPosition = i.backgroundPosition || "0 0");
    }, t.prototype.setCenter = function(e) {
      this.center = e;
    }, t.prototype.getPosFromLatLng = function(e) {
      var n = this.getProjection().fromLatLngToDivPixel(e);
      return n !== null && (n.x -= this.anchorIcon[1], n.y -= this.anchorIcon[0]), n;
    }, t;
  }()
), ps = (
  /** @class */
  function() {
    function t(e) {
      this.markerClusterer = e, this.map = this.markerClusterer.getMap(), this.gridSize = this.markerClusterer.getGridSize(), this.minClusterSize = this.markerClusterer.getMinimumClusterSize(), this.averageCenter = this.markerClusterer.getAverageCenter(), this.markers = [], this.center = void 0, this.bounds = null, this.clusterIcon = new ls(this, this.markerClusterer.getStyles()), this.getSize = this.getSize.bind(this), this.getMarkers = this.getMarkers.bind(this), this.getCenter = this.getCenter.bind(this), this.getMap = this.getMap.bind(this), this.getClusterer = this.getClusterer.bind(this), this.getBounds = this.getBounds.bind(this), this.remove = this.remove.bind(this), this.addMarker = this.addMarker.bind(this), this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this), this.calculateBounds = this.calculateBounds.bind(this), this.updateIcon = this.updateIcon.bind(this), this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
    }
    return t.prototype.getSize = function() {
      return this.markers.length;
    }, t.prototype.getMarkers = function() {
      return this.markers;
    }, t.prototype.getCenter = function() {
      return this.center;
    }, t.prototype.getMap = function() {
      return this.map;
    }, t.prototype.getClusterer = function() {
      return this.markerClusterer;
    }, t.prototype.getBounds = function() {
      for (var e = new google.maps.LatLngBounds(this.center, this.center), n = this.getMarkers(), i = 0, s = n; i < s.length; i++) {
        var r = s[i], o = r.getPosition();
        o && e.extend(o);
      }
      return e;
    }, t.prototype.remove = function() {
      this.clusterIcon.setMap(null), this.markers = [], delete this.markers;
    }, t.prototype.addMarker = function(e) {
      var n;
      if (this.isMarkerAlreadyAdded(e))
        return !1;
      if (this.center) {
        if (this.averageCenter) {
          var i = e.getPosition();
          if (i) {
            var s = this.markers.length + 1;
            this.center = new google.maps.LatLng((this.center.lat() * (s - 1) + i.lat()) / s, (this.center.lng() * (s - 1) + i.lng()) / s), this.calculateBounds();
          }
        }
      } else {
        var i = e.getPosition();
        i && (this.center = i, this.calculateBounds());
      }
      e.isAdded = !0, this.markers.push(e);
      var r = this.markers.length, o = this.markerClusterer.getMaxZoom(), l = (n = this.map) === null || n === void 0 ? void 0 : n.getZoom();
      if (o !== null && typeof l < "u" && l > o)
        e.getMap() !== this.map && e.setMap(this.map);
      else if (r < this.minClusterSize)
        e.getMap() !== this.map && e.setMap(this.map);
      else if (r === this.minClusterSize)
        for (var p = 0, d = this.markers; p < d.length; p++) {
          var u = d[p];
          u.setMap(null);
        }
      else
        e.setMap(null);
      return !0;
    }, t.prototype.isMarkerInClusterBounds = function(e) {
      if (this.bounds !== null) {
        var n = e.getPosition();
        if (n)
          return this.bounds.contains(n);
      }
      return !1;
    }, t.prototype.calculateBounds = function() {
      this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
    }, t.prototype.updateIcon = function() {
      var e, n = this.markers.length, i = this.markerClusterer.getMaxZoom(), s = (e = this.map) === null || e === void 0 ? void 0 : e.getZoom();
      if (i !== null && typeof s < "u" && s > i) {
        this.clusterIcon.hide();
        return;
      }
      if (n < this.minClusterSize) {
        this.clusterIcon.hide();
        return;
      }
      this.center && this.clusterIcon.setCenter(this.center), this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length)), this.clusterIcon.show();
    }, t.prototype.isMarkerAlreadyAdded = function(e) {
      if (this.markers.includes)
        return this.markers.includes(e);
      for (var n = 0; n < this.markers.length; n++)
        if (e === this.markers[n])
          return !0;
      return !1;
    }, t;
  }()
);
function us(t, e) {
  var n = t.length, i = n.toString().length, s = Math.min(i, e);
  return {
    text: n.toString(),
    index: s,
    title: ""
  };
}
var ds = 2e3, cs = 500, gs = "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m", hs = "png", fs = [53, 56, 66, 78, 90], ms = "cluster", fi = (
  /** @class */
  function() {
    function t(e, n, i) {
      n === void 0 && (n = []), i === void 0 && (i = {}), this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this), this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this), this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this), this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this), this.addToClosestCluster = this.addToClosestCluster.bind(this), this.getImageExtension = this.getImageExtension.bind(this), this.setImageExtension = this.setImageExtension.bind(this), this.getExtendedBounds = this.getExtendedBounds.bind(this), this.getAverageCenter = this.getAverageCenter.bind(this), this.setAverageCenter = this.setAverageCenter.bind(this), this.getTotalClusters = this.getTotalClusters.bind(this), this.fitMapToMarkers = this.fitMapToMarkers.bind(this), this.getIgnoreHidden = this.getIgnoreHidden.bind(this), this.setIgnoreHidden = this.setIgnoreHidden.bind(this), this.getClusterClass = this.getClusterClass.bind(this), this.setClusterClass = this.setClusterClass.bind(this), this.getTotalMarkers = this.getTotalMarkers.bind(this), this.getZoomOnClick = this.getZoomOnClick.bind(this), this.setZoomOnClick = this.setZoomOnClick.bind(this), this.getBatchSizeIE = this.getBatchSizeIE.bind(this), this.setBatchSizeIE = this.setBatchSizeIE.bind(this), this.createClusters = this.createClusters.bind(this), this.onZoomChanged = this.onZoomChanged.bind(this), this.getImageSizes = this.getImageSizes.bind(this), this.setImageSizes = this.setImageSizes.bind(this), this.getCalculator = this.getCalculator.bind(this), this.setCalculator = this.setCalculator.bind(this), this.removeMarkers = this.removeMarkers.bind(this), this.resetViewport = this.resetViewport.bind(this), this.getImagePath = this.getImagePath.bind(this), this.setImagePath = this.setImagePath.bind(this), this.pushMarkerTo = this.pushMarkerTo.bind(this), this.removeMarker = this.removeMarker.bind(this), this.clearMarkers = this.clearMarkers.bind(this), this.setupStyles = this.setupStyles.bind(this), this.getGridSize = this.getGridSize.bind(this), this.setGridSize = this.setGridSize.bind(this), this.getClusters = this.getClusters.bind(this), this.getMaxZoom = this.getMaxZoom.bind(this), this.setMaxZoom = this.setMaxZoom.bind(this), this.getMarkers = this.getMarkers.bind(this), this.addMarkers = this.addMarkers.bind(this), this.getStyles = this.getStyles.bind(this), this.setStyles = this.setStyles.bind(this), this.addMarker = this.addMarker.bind(this), this.onRemove = this.onRemove.bind(this), this.getTitle = this.getTitle.bind(this), this.setTitle = this.setTitle.bind(this), this.repaint = this.repaint.bind(this), this.onIdle = this.onIdle.bind(this), this.redraw = this.redraw.bind(this), this.onAdd = this.onAdd.bind(this), this.draw = this.draw.bind(this), this.extend = this.extend.bind(this), this.extend(t, google.maps.OverlayView), this.markers = [], this.clusters = [], this.listeners = [], this.activeMap = null, this.ready = !1, this.gridSize = i.gridSize || 60, this.minClusterSize = i.minimumClusterSize || 2, this.maxZoom = i.maxZoom || null, this.styles = i.styles || [], this.title = i.title || "", this.zoomOnClick = !0, i.zoomOnClick !== void 0 && (this.zoomOnClick = i.zoomOnClick), this.averageCenter = !1, i.averageCenter !== void 0 && (this.averageCenter = i.averageCenter), this.ignoreHidden = !1, i.ignoreHidden !== void 0 && (this.ignoreHidden = i.ignoreHidden), this.enableRetinaIcons = !1, i.enableRetinaIcons !== void 0 && (this.enableRetinaIcons = i.enableRetinaIcons), this.imagePath = i.imagePath || gs, this.imageExtension = i.imageExtension || hs, this.imageSizes = i.imageSizes || fs, this.calculator = i.calculator || us, this.batchSize = i.batchSize || ds, this.batchSizeIE = i.batchSizeIE || cs, this.clusterClass = i.clusterClass || ms, navigator.userAgent.toLowerCase().indexOf("msie") !== -1 && (this.batchSize = this.batchSizeIE), this.timerRefStatic = null, this.setupStyles(), this.addMarkers(n, !0), this.setMap(e);
    }
    return t.prototype.onZoomChanged = function() {
      var e, n;
      this.resetViewport(!1), (((e = this.getMap()) === null || e === void 0 ? void 0 : e.getZoom()) === (this.get("minZoom") || 0) || ((n = this.getMap()) === null || n === void 0 ? void 0 : n.getZoom()) === this.get("maxZoom")) && google.maps.event.trigger(this, "idle");
    }, t.prototype.onIdle = function() {
      this.redraw();
    }, t.prototype.onAdd = function() {
      var e = this.getMap();
      this.activeMap = e, this.ready = !0, this.repaint(), e !== null && (this.listeners = [google.maps.event.addListener(e, "zoom_changed", this.onZoomChanged), google.maps.event.addListener(e, "idle", this.onIdle)]);
    }, t.prototype.onRemove = function() {
      for (var e = 0, n = this.markers; e < n.length; e++) {
        var i = n[e];
        i.getMap() !== this.activeMap && i.setMap(this.activeMap);
      }
      for (var s = 0, r = this.clusters; s < r.length; s++) {
        var o = r[s];
        o.remove();
      }
      this.clusters = [];
      for (var l = 0, p = this.listeners; l < p.length; l++) {
        var d = p[l];
        google.maps.event.removeListener(d);
      }
      this.listeners = [], this.activeMap = null, this.ready = !1;
    }, t.prototype.draw = function() {
    }, t.prototype.getMap = function() {
      return null;
    }, t.prototype.getPanes = function() {
      return null;
    }, t.prototype.getProjection = function() {
      return {
        fromContainerPixelToLatLng: function() {
          return null;
        },
        fromDivPixelToLatLng: function() {
          return null;
        },
        fromLatLngToContainerPixel: function() {
          return null;
        },
        fromLatLngToDivPixel: function() {
          return null;
        },
        getVisibleRegion: function() {
          return null;
        },
        getWorldWidth: function() {
          return 0;
        }
      };
    }, t.prototype.setMap = function() {
    }, t.prototype.addListener = function() {
      return {
        remove: function() {
        }
      };
    }, t.prototype.bindTo = function() {
    }, t.prototype.get = function() {
    }, t.prototype.notify = function() {
    }, t.prototype.set = function() {
    }, t.prototype.setValues = function() {
    }, t.prototype.unbind = function() {
    }, t.prototype.unbindAll = function() {
    }, t.prototype.setupStyles = function() {
      if (!(this.styles.length > 0))
        for (var e = 0; e < this.imageSizes.length; e++)
          this.styles.push({
            url: "".concat(this.imagePath + (e + 1), ".").concat(this.imageExtension),
            height: this.imageSizes[e] || 0,
            width: this.imageSizes[e] || 0
          });
    }, t.prototype.fitMapToMarkers = function() {
      for (var e = this.getMarkers(), n = new google.maps.LatLngBounds(), i = 0, s = e; i < s.length; i++) {
        var r = s[i], o = r.getPosition();
        o && n.extend(o);
      }
      var l = this.getMap();
      l !== null && "fitBounds" in l && l.fitBounds(n);
    }, t.prototype.getGridSize = function() {
      return this.gridSize;
    }, t.prototype.setGridSize = function(e) {
      this.gridSize = e;
    }, t.prototype.getMinimumClusterSize = function() {
      return this.minClusterSize;
    }, t.prototype.setMinimumClusterSize = function(e) {
      this.minClusterSize = e;
    }, t.prototype.getMaxZoom = function() {
      return this.maxZoom;
    }, t.prototype.setMaxZoom = function(e) {
      this.maxZoom = e;
    }, t.prototype.getStyles = function() {
      return this.styles;
    }, t.prototype.setStyles = function(e) {
      this.styles = e;
    }, t.prototype.getTitle = function() {
      return this.title;
    }, t.prototype.setTitle = function(e) {
      this.title = e;
    }, t.prototype.getZoomOnClick = function() {
      return this.zoomOnClick;
    }, t.prototype.setZoomOnClick = function(e) {
      this.zoomOnClick = e;
    }, t.prototype.getAverageCenter = function() {
      return this.averageCenter;
    }, t.prototype.setAverageCenter = function(e) {
      this.averageCenter = e;
    }, t.prototype.getIgnoreHidden = function() {
      return this.ignoreHidden;
    }, t.prototype.setIgnoreHidden = function(e) {
      this.ignoreHidden = e;
    }, t.prototype.getEnableRetinaIcons = function() {
      return this.enableRetinaIcons;
    }, t.prototype.setEnableRetinaIcons = function(e) {
      this.enableRetinaIcons = e;
    }, t.prototype.getImageExtension = function() {
      return this.imageExtension;
    }, t.prototype.setImageExtension = function(e) {
      this.imageExtension = e;
    }, t.prototype.getImagePath = function() {
      return this.imagePath;
    }, t.prototype.setImagePath = function(e) {
      this.imagePath = e;
    }, t.prototype.getImageSizes = function() {
      return this.imageSizes;
    }, t.prototype.setImageSizes = function(e) {
      this.imageSizes = e;
    }, t.prototype.getCalculator = function() {
      return this.calculator;
    }, t.prototype.setCalculator = function(e) {
      this.calculator = e;
    }, t.prototype.getBatchSizeIE = function() {
      return this.batchSizeIE;
    }, t.prototype.setBatchSizeIE = function(e) {
      this.batchSizeIE = e;
    }, t.prototype.getClusterClass = function() {
      return this.clusterClass;
    }, t.prototype.setClusterClass = function(e) {
      this.clusterClass = e;
    }, t.prototype.getMarkers = function() {
      return this.markers;
    }, t.prototype.getTotalMarkers = function() {
      return this.markers.length;
    }, t.prototype.getClusters = function() {
      return this.clusters;
    }, t.prototype.getTotalClusters = function() {
      return this.clusters.length;
    }, t.prototype.addMarker = function(e, n) {
      this.pushMarkerTo(e), n || this.redraw();
    }, t.prototype.addMarkers = function(e, n) {
      for (var i in e)
        if (Object.prototype.hasOwnProperty.call(e, i)) {
          var s = e[i];
          s && this.pushMarkerTo(s);
        }
      n || this.redraw();
    }, t.prototype.pushMarkerTo = function(e) {
      var n = this;
      e.getDraggable() && google.maps.event.addListener(e, "dragend", function() {
        n.ready && (e.isAdded = !1, n.repaint());
      }), e.isAdded = !1, this.markers.push(e);
    }, t.prototype.removeMarker_ = function(e) {
      var n = -1;
      if (this.markers.indexOf)
        n = this.markers.indexOf(e);
      else
        for (var i = 0; i < this.markers.length; i++)
          if (e === this.markers[i]) {
            n = i;
            break;
          }
      return n === -1 ? !1 : (e.setMap(null), this.markers.splice(n, 1), !0);
    }, t.prototype.removeMarker = function(e, n) {
      var i = this.removeMarker_(e);
      return !n && i && this.repaint(), i;
    }, t.prototype.removeMarkers = function(e, n) {
      for (var i = !1, s = 0, r = e; s < r.length; s++) {
        var o = r[s];
        i = i || this.removeMarker_(o);
      }
      return !n && i && this.repaint(), i;
    }, t.prototype.clearMarkers = function() {
      this.resetViewport(!0), this.markers = [];
    }, t.prototype.repaint = function() {
      var e = this.clusters.slice();
      this.clusters = [], this.resetViewport(!1), this.redraw(), setTimeout(function() {
        for (var i = 0, s = e; i < s.length; i++) {
          var r = s[i];
          r.remove();
        }
      }, 0);
    }, t.prototype.getExtendedBounds = function(e) {
      var n = this.getProjection(), i = n.fromLatLngToDivPixel(
        // Turn the bounds into latlng.
        new google.maps.LatLng(e.getNorthEast().lat(), e.getNorthEast().lng())
      );
      i !== null && (i.x += this.gridSize, i.y -= this.gridSize);
      var s = n.fromLatLngToDivPixel(
        // Turn the bounds into latlng.
        new google.maps.LatLng(e.getSouthWest().lat(), e.getSouthWest().lng())
      );
      if (s !== null && (s.x -= this.gridSize, s.y += this.gridSize), i !== null) {
        var r = n.fromDivPixelToLatLng(i);
        r !== null && e.extend(r);
      }
      if (s !== null) {
        var o = n.fromDivPixelToLatLng(s);
        o !== null && e.extend(o);
      }
      return e;
    }, t.prototype.redraw = function() {
      this.createClusters(0);
    }, t.prototype.resetViewport = function(e) {
      for (var n = 0, i = this.clusters; n < i.length; n++) {
        var s = i[n];
        s.remove();
      }
      this.clusters = [];
      for (var r = 0, o = this.markers; r < o.length; r++) {
        var l = o[r];
        l.isAdded = !1, e && l.setMap(null);
      }
    }, t.prototype.distanceBetweenPoints = function(e, n) {
      var i = 6371, s = (n.lat() - e.lat()) * Math.PI / 180, r = (n.lng() - e.lng()) * Math.PI / 180, o = Math.sin(s / 2) * Math.sin(s / 2) + Math.cos(e.lat() * Math.PI / 180) * Math.cos(n.lat() * Math.PI / 180) * Math.sin(r / 2) * Math.sin(r / 2);
      return i * (2 * Math.atan2(Math.sqrt(o), Math.sqrt(1 - o)));
    }, t.prototype.isMarkerInBounds = function(e, n) {
      var i = e.getPosition();
      return i ? n.contains(i) : !1;
    }, t.prototype.addToClosestCluster = function(e) {
      for (var n, i = 4e4, s = null, r = 0, o = this.clusters; r < o.length; r++) {
        var l = o[r];
        n = l;
        var p = n.getCenter(), d = e.getPosition();
        if (p && d) {
          var u = this.distanceBetweenPoints(p, d);
          u < i && (i = u, s = n);
        }
      }
      s && s.isMarkerInClusterBounds(e) ? s.addMarker(e) : (n = new ps(this), n.addMarker(e), this.clusters.push(n));
    }, t.prototype.createClusters = function(e) {
      var n = this;
      if (this.ready) {
        e === 0 && (google.maps.event.trigger(this, "clusteringbegin", this), this.timerRefStatic !== null && (window.clearTimeout(this.timerRefStatic), delete this.timerRefStatic));
        for (var i = this.getMap(), s = i !== null && ("getBounds" in i) ? i.getBounds() : null, r = (i == null ? void 0 : i.getZoom()) || 0, o = r > 3 ? new google.maps.LatLngBounds(s == null ? void 0 : s.getSouthWest(), s == null ? void 0 : s.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625)), l = this.getExtendedBounds(o), p = Math.min(e + this.batchSize, this.markers.length), d = e; d < p; d++) {
          var u = this.markers[d];
          u && !u.isAdded && this.isMarkerInBounds(u, l) && (!this.ignoreHidden || this.ignoreHidden && u.getVisible()) && this.addToClosestCluster(u);
        }
        if (p < this.markers.length)
          this.timerRefStatic = window.setTimeout(function() {
            n.createClusters(p);
          }, 0);
        else {
          this.timerRefStatic = null, google.maps.event.trigger(this, "clusteringend", this);
          for (var h = 0, g = this.clusters; h < g.length; h++) {
            var y = g[h];
            y.updateIcon();
          }
        }
      }
    }, t.prototype.extend = function(e, n) {
      return (function(s) {
        for (var r in s.prototype) {
          var o = r;
          this.prototype[o] = s.prototype[o];
        }
        return this;
      }).apply(e, [n]);
    }, t;
  }()
);
function nn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function vs(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? nn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : nn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var ue = {
  onClick: "click",
  onClusteringBegin: "clusteringbegin",
  onClusteringEnd: "clusteringend",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover"
}, K = {
  averageCenter(t, e) {
    t.setAverageCenter(e);
  },
  batchSizeIE(t, e) {
    t.setBatchSizeIE(e);
  },
  calculator(t, e) {
    t.setCalculator(e);
  },
  clusterClass(t, e) {
    t.setClusterClass(e);
  },
  enableRetinaIcons(t, e) {
    t.setEnableRetinaIcons(e);
  },
  gridSize(t, e) {
    t.setGridSize(e);
  },
  ignoreHidden(t, e) {
    t.setIgnoreHidden(e);
  },
  imageExtension(t, e) {
    t.setImageExtension(e);
  },
  imagePath(t, e) {
    t.setImagePath(e);
  },
  imageSizes(t, e) {
    t.setImageSizes(e);
  },
  maxZoom(t, e) {
    t.setMaxZoom(e);
  },
  minimumClusterSize(t, e) {
    t.setMinimumClusterSize(e);
  },
  styles(t, e) {
    t.setStyles(e);
  },
  title(t, e) {
    t.setTitle(e);
  },
  zoomOnClick(t, e) {
    t.setZoomOnClick(e);
  }
}, ys = {};
function Ls(t) {
  var {
    children: e,
    options: n,
    averageCenter: i,
    batchSizeIE: s,
    calculator: r,
    clusterClass: o,
    enableRetinaIcons: l,
    gridSize: p,
    ignoreHidden: d,
    imageExtension: u,
    imagePath: h,
    imageSizes: g,
    maxZoom: y,
    minimumClusterSize: c,
    styles: O,
    title: w,
    zoomOnClick: P,
    onClick: x,
    onClusteringBegin: D,
    onClusteringEnd: b,
    onMouseOver: v,
    onMouseOut: C,
    onLoad: k,
    onUnmount: I
  } = t, [M, E] = f(null), S = ae(A), [U, $] = f(null), [T, B] = f(null), [W, Y] = f(null), [F, q] = f(null), [H, J] = f(null);
  return a(() => {
    M && C && (F !== null && google.maps.event.removeListener(F), q(google.maps.event.addListener(M, ue.onMouseOut, C)));
  }, [C]), a(() => {
    M && v && (H !== null && google.maps.event.removeListener(H), J(google.maps.event.addListener(M, ue.onMouseOver, v)));
  }, [v]), a(() => {
    M && x && (U !== null && google.maps.event.removeListener(U), $(google.maps.event.addListener(M, ue.onClick, x)));
  }, [x]), a(() => {
    M && D && (T !== null && google.maps.event.removeListener(T), B(google.maps.event.addListener(M, ue.onClusteringBegin, D)));
  }, [D]), a(() => {
    M && b && (W !== null && google.maps.event.removeListener(W), B(google.maps.event.addListener(M, ue.onClusteringEnd, b)));
  }, [b]), a(() => {
    typeof i < "u" && M !== null && K.averageCenter(M, i);
  }, [M, i]), a(() => {
    typeof s < "u" && M !== null && K.batchSizeIE(M, s);
  }, [M, s]), a(() => {
    typeof r < "u" && M !== null && K.calculator(M, r);
  }, [M, r]), a(() => {
    typeof o < "u" && M !== null && K.clusterClass(M, o);
  }, [M, o]), a(() => {
    typeof l < "u" && M !== null && K.enableRetinaIcons(M, l);
  }, [M, l]), a(() => {
    typeof p < "u" && M !== null && K.gridSize(M, p);
  }, [M, p]), a(() => {
    typeof d < "u" && M !== null && K.ignoreHidden(M, d);
  }, [M, d]), a(() => {
    typeof u < "u" && M !== null && K.imageExtension(M, u);
  }, [M, u]), a(() => {
    typeof h < "u" && M !== null && K.imagePath(M, h);
  }, [M, h]), a(() => {
    typeof g < "u" && M !== null && K.imageSizes(M, g);
  }, [M, g]), a(() => {
    typeof y < "u" && M !== null && K.maxZoom(M, y);
  }, [M, y]), a(() => {
    typeof c < "u" && M !== null && K.minimumClusterSize(M, c);
  }, [M, c]), a(() => {
    typeof O < "u" && M !== null && K.styles(M, O);
  }, [M, O]), a(() => {
    typeof w < "u" && M !== null && K.title(M, w);
  }, [M, w]), a(() => {
    typeof P < "u" && M !== null && K.zoomOnClick(M, P);
  }, [M, P]), a(() => {
    if (S) {
      var Q = vs({}, n || ys), j = new fi(S, [], Q);
      return i && K.averageCenter(j, i), s && K.batchSizeIE(j, s), r && K.calculator(j, r), o && K.clusterClass(j, o), l && K.enableRetinaIcons(j, l), p && K.gridSize(j, p), d && K.ignoreHidden(j, d), u && K.imageExtension(j, u), h && K.imagePath(j, h), g && K.imageSizes(j, g), y && K.maxZoom(j, y), c && K.minimumClusterSize(j, c), O && K.styles(j, O), w && K.title(j, w), P && K.zoomOnClick(j, P), C && q(google.maps.event.addListener(j, ue.onMouseOut, C)), v && J(google.maps.event.addListener(j, ue.onMouseOver, v)), x && $(google.maps.event.addListener(j, ue.onClick, x)), D && B(google.maps.event.addListener(j, ue.onClusteringBegin, D)), b && Y(google.maps.event.addListener(j, ue.onClusteringEnd, b)), E(j), k && k(j), () => {
        F !== null && google.maps.event.removeListener(F), H !== null && google.maps.event.removeListener(H), U !== null && google.maps.event.removeListener(U), T !== null && google.maps.event.removeListener(T), W !== null && google.maps.event.removeListener(W), I && I(j);
      };
    }
  }, []), M !== null && e(M) || null;
}
oe(Ls);
class bs extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      markerClusterer: null
    }), m(this, "setClustererCallback", () => {
      this.state.markerClusterer !== null && this.props.onLoad && this.props.onLoad(this.state.markerClusterer);
    });
  }
  componentDidMount() {
    if (this.context) {
      var e = new fi(this.context, [], this.props.options);
      this.registeredEvents = N({
        updaterMap: K,
        eventMap: ue,
        prevProps: {},
        nextProps: this.props,
        instance: e
      }), this.setState(() => ({
        markerClusterer: e
      }), this.setClustererCallback);
    }
  }
  componentDidUpdate(e) {
    this.state.markerClusterer && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: K,
      eventMap: ue,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.markerClusterer
    }));
  }
  componentWillUnmount() {
    this.state.markerClusterer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.markerClusterer), V(this.registeredEvents), this.state.markerClusterer.setMap(null));
  }
  render() {
    return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
  }
}
m(bs, "contextType", A);
function sn(t) {
  t.cancelBubble = !0, t.stopPropagation && t.stopPropagation();
}
var mi = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = {}), this.getCloseClickHandler = this.getCloseClickHandler.bind(this), this.closeClickHandler = this.closeClickHandler.bind(this), this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this), this.addClickHandler = this.addClickHandler.bind(this), this.getCloseBoxImg = this.getCloseBoxImg.bind(this), this.getBoxWidths = this.getBoxWidths.bind(this), this.setBoxStyle = this.setBoxStyle.bind(this), this.setPosition = this.setPosition.bind(this), this.getPosition = this.getPosition.bind(this), this.setOptions = this.setOptions.bind(this), this.setContent = this.setContent.bind(this), this.setVisible = this.setVisible.bind(this), this.getContent = this.getContent.bind(this), this.getVisible = this.getVisible.bind(this), this.setZIndex = this.setZIndex.bind(this), this.getZIndex = this.getZIndex.bind(this), this.onRemove = this.onRemove.bind(this), this.panBox = this.panBox.bind(this), this.extend = this.extend.bind(this), this.close = this.close.bind(this), this.draw = this.draw.bind(this), this.show = this.show.bind(this), this.hide = this.hide.bind(this), this.open = this.open.bind(this), this.extend(t, google.maps.OverlayView), this.content = e.content || "", this.disableAutoPan = e.disableAutoPan || !1, this.maxWidth = e.maxWidth || 0, this.pixelOffset = e.pixelOffset || new google.maps.Size(0, 0), this.position = e.position || new google.maps.LatLng(0, 0), this.zIndex = e.zIndex || null, this.boxClass = e.boxClass || "infoBox", this.boxStyle = e.boxStyle || {}, this.closeBoxMargin = e.closeBoxMargin || "2px", this.closeBoxURL = e.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif", e.closeBoxURL === "" && (this.closeBoxURL = ""), this.infoBoxClearance = e.infoBoxClearance || new google.maps.Size(1, 1), typeof e.visible > "u" && (typeof e.isHidden > "u" ? e.visible = !0 : e.visible = !e.isHidden), this.isHidden = !e.visible, this.alignBottom = e.alignBottom || !1, this.pane = e.pane || "floatPane", this.enableEventPropagation = e.enableEventPropagation || !1, this.div = null, this.closeListener = null, this.moveListener = null, this.mapListener = null, this.contextListener = null, this.eventListeners = null, this.fixedWidthSet = null;
    }
    return t.prototype.createInfoBoxDiv = function() {
      var e = this, n = function(u) {
        u.returnValue = !1, u.preventDefault && u.preventDefault(), e.enableEventPropagation || sn(u);
      };
      if (!this.div) {
        this.div = document.createElement("div"), this.setBoxStyle(), typeof this.content == "string" ? this.div.innerHTML = this.getCloseBoxImg() + this.content : (this.div.innerHTML = this.getCloseBoxImg(), this.div.appendChild(this.content));
        var i = this.getPanes();
        if (i !== null && i[this.pane].appendChild(this.div), this.addClickHandler(), this.div.style.width)
          this.fixedWidthSet = !0;
        else if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth)
          this.div.style.width = this.maxWidth + "px", this.fixedWidthSet = !0;
        else {
          var s = this.getBoxWidths();
          this.div.style.width = this.div.offsetWidth - s.left - s.right + "px", this.fixedWidthSet = !1;
        }
        if (this.panBox(this.disableAutoPan), !this.enableEventPropagation) {
          this.eventListeners = [];
          for (var r = ["mousedown", "mouseover", "mouseout", "mouseup", "click", "dblclick", "touchstart", "touchend", "touchmove"], o = 0, l = r; o < l.length; o++) {
            var p = l[o];
            this.eventListeners.push(google.maps.event.addListener(this.div, p, sn));
          }
          this.eventListeners.push(google.maps.event.addListener(this.div, "mouseover", function() {
            e.div && (e.div.style.cursor = "default");
          }));
        }
        this.contextListener = google.maps.event.addListener(this.div, "contextmenu", n), google.maps.event.trigger(this, "domready");
      }
    }, t.prototype.getCloseBoxImg = function() {
      var e = "";
      return this.closeBoxURL !== "" && (e = '<img alt=""', e += ' aria-hidden="true"', e += " src='" + this.closeBoxURL + "'", e += " align=right", e += " style='", e += " position: relative;", e += " cursor: pointer;", e += " margin: " + this.closeBoxMargin + ";", e += "'>"), e;
    }, t.prototype.addClickHandler = function() {
      this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== "" ? google.maps.event.addListener(this.div.firstChild, "click", this.getCloseClickHandler()) : null;
    }, t.prototype.closeClickHandler = function(e) {
      e.cancelBubble = !0, e.stopPropagation && e.stopPropagation(), google.maps.event.trigger(this, "closeclick"), this.close();
    }, t.prototype.getCloseClickHandler = function() {
      return this.closeClickHandler;
    }, t.prototype.panBox = function(e) {
      if (this.div && !e) {
        var n = this.getMap();
        if (n instanceof google.maps.Map) {
          var i = 0, s = 0, r = n.getBounds();
          r && !r.contains(this.position) && n.setCenter(this.position);
          var o = n.getDiv(), l = o.offsetWidth, p = o.offsetHeight, d = this.pixelOffset.width, u = this.pixelOffset.height, h = this.div.offsetWidth, g = this.div.offsetHeight, y = this.infoBoxClearance.width, c = this.infoBoxClearance.height, O = this.getProjection(), w = O.fromLatLngToContainerPixel(this.position);
          w !== null && (w.x < -d + y ? i = w.x + d - y : w.x + h + d + y > l && (i = w.x + h + d + y - l), this.alignBottom ? w.y < -u + c + g ? s = w.y + u - c - g : w.y + u + c > p && (s = w.y + u + c - p) : w.y < -u + c ? s = w.y + u - c : w.y + g + u + c > p && (s = w.y + g + u + c - p)), i === 0 && s === 0 || n.panBy(i, s);
        }
      }
    }, t.prototype.setBoxStyle = function() {
      if (this.div) {
        this.div.className = this.boxClass, this.div.style.cssText = "";
        var e = this.boxStyle;
        for (var n in e)
          Object.prototype.hasOwnProperty.call(e, n) && (this.div.style[n] = e[n]);
        if (this.div.style.webkitTransform = "translateZ(0)", typeof this.div.style.opacity < "u" && this.div.style.opacity !== "") {
          var i = parseFloat(this.div.style.opacity || "");
          this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + i * 100 + ')"', this.div.style.filter = "alpha(opacity=" + i * 100 + ")";
        }
        this.div.style.position = "absolute", this.div.style.visibility = "hidden", this.zIndex !== null && (this.div.style.zIndex = this.zIndex + ""), this.div.style.overflow || (this.div.style.overflow = "auto");
      }
    }, t.prototype.getBoxWidths = function() {
      var e = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      };
      if (!this.div)
        return e;
      if (document.defaultView) {
        var n = this.div.ownerDocument, i = n && n.defaultView ? n.defaultView.getComputedStyle(this.div, "") : null;
        i && (e.top = parseInt(i.borderTopWidth || "", 10) || 0, e.bottom = parseInt(i.borderBottomWidth || "", 10) || 0, e.left = parseInt(i.borderLeftWidth || "", 10) || 0, e.right = parseInt(i.borderRightWidth || "", 10) || 0);
      } else if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document.documentElement.currentStyle
      ) {
        var s = this.div.currentStyle;
        s && (e.top = parseInt(s.borderTopWidth || "", 10) || 0, e.bottom = parseInt(s.borderBottomWidth || "", 10) || 0, e.left = parseInt(s.borderLeftWidth || "", 10) || 0, e.right = parseInt(s.borderRightWidth || "", 10) || 0);
      }
      return e;
    }, t.prototype.onRemove = function() {
      this.div && this.div.parentNode && (this.div.parentNode.removeChild(this.div), this.div = null);
    }, t.prototype.draw = function() {
      if (this.createInfoBoxDiv(), this.div) {
        var e = this.getProjection(), n = e.fromLatLngToDivPixel(this.position);
        n !== null && (this.div.style.left = n.x + this.pixelOffset.width + "px", this.alignBottom ? this.div.style.bottom = -(n.y + this.pixelOffset.height) + "px" : this.div.style.top = n.y + this.pixelOffset.height + "px"), this.isHidden ? this.div.style.visibility = "hidden" : this.div.style.visibility = "visible";
      }
    }, t.prototype.setOptions = function(e) {
      e === void 0 && (e = {}), typeof e.boxClass < "u" && (this.boxClass = e.boxClass, this.setBoxStyle()), typeof e.boxStyle < "u" && (this.boxStyle = e.boxStyle, this.setBoxStyle()), typeof e.content < "u" && this.setContent(e.content), typeof e.disableAutoPan < "u" && (this.disableAutoPan = e.disableAutoPan), typeof e.maxWidth < "u" && (this.maxWidth = e.maxWidth), typeof e.pixelOffset < "u" && (this.pixelOffset = e.pixelOffset), typeof e.alignBottom < "u" && (this.alignBottom = e.alignBottom), typeof e.position < "u" && this.setPosition(e.position), typeof e.zIndex < "u" && this.setZIndex(e.zIndex), typeof e.closeBoxMargin < "u" && (this.closeBoxMargin = e.closeBoxMargin), typeof e.closeBoxURL < "u" && (this.closeBoxURL = e.closeBoxURL), typeof e.infoBoxClearance < "u" && (this.infoBoxClearance = e.infoBoxClearance), typeof e.isHidden < "u" && (this.isHidden = e.isHidden), typeof e.visible < "u" && (this.isHidden = !e.visible), typeof e.enableEventPropagation < "u" && (this.enableEventPropagation = e.enableEventPropagation), this.div && this.draw();
    }, t.prototype.setContent = function(e) {
      this.content = e, this.div && (this.closeListener && (google.maps.event.removeListener(this.closeListener), this.closeListener = null), this.fixedWidthSet || (this.div.style.width = ""), typeof e == "string" ? this.div.innerHTML = this.getCloseBoxImg() + e : (this.div.innerHTML = this.getCloseBoxImg(), this.div.appendChild(e)), this.fixedWidthSet || (this.div.style.width = this.div.offsetWidth + "px", typeof e == "string" ? this.div.innerHTML = this.getCloseBoxImg() + e : (this.div.innerHTML = this.getCloseBoxImg(), this.div.appendChild(e))), this.addClickHandler()), google.maps.event.trigger(this, "content_changed");
    }, t.prototype.setPosition = function(e) {
      this.position = e, this.div && this.draw(), google.maps.event.trigger(this, "position_changed");
    }, t.prototype.setVisible = function(e) {
      this.isHidden = !e, this.div && (this.div.style.visibility = this.isHidden ? "hidden" : "visible");
    }, t.prototype.setZIndex = function(e) {
      this.zIndex = e, this.div && (this.div.style.zIndex = e + ""), google.maps.event.trigger(this, "zindex_changed");
    }, t.prototype.getContent = function() {
      return this.content;
    }, t.prototype.getPosition = function() {
      return this.position;
    }, t.prototype.getZIndex = function() {
      return this.zIndex;
    }, t.prototype.getVisible = function() {
      var e = this.getMap();
      return typeof e > "u" || e === null ? !1 : !this.isHidden;
    }, t.prototype.show = function() {
      this.isHidden = !1, this.div && (this.div.style.visibility = "visible");
    }, t.prototype.hide = function() {
      this.isHidden = !0, this.div && (this.div.style.visibility = "hidden");
    }, t.prototype.open = function(e, n) {
      var i = this;
      n && (this.position = n.getPosition(), this.moveListener = google.maps.event.addListener(n, "position_changed", function() {
        var s = n.getPosition();
        i.setPosition(s);
      }), this.mapListener = google.maps.event.addListener(n, "map_changed", function() {
        i.setMap(n.map);
      })), this.setMap(e), this.div && this.panBox();
    }, t.prototype.close = function() {
      if (this.closeListener && (google.maps.event.removeListener(this.closeListener), this.closeListener = null), this.eventListeners) {
        for (var e = 0, n = this.eventListeners; e < n.length; e++) {
          var i = n[e];
          google.maps.event.removeListener(i);
        }
        this.eventListeners = null;
      }
      this.moveListener && (google.maps.event.removeListener(this.moveListener), this.moveListener = null), this.mapListener && (google.maps.event.removeListener(this.mapListener), this.mapListener = null), this.contextListener && (google.maps.event.removeListener(this.contextListener), this.contextListener = null), this.setMap(null);
    }, t.prototype.extend = function(e, n) {
      return (function(s) {
        for (var r in s.prototype)
          Object.prototype.hasOwnProperty.call(this, r) || (this.prototype[r] = s.prototype[r]);
        return this;
      }).apply(e, [n]);
    }, t;
  }()
), Cs = ["position"], Ms = ["position"];
function rn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Xe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : rn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var on = {
  onCloseClick: "closeclick",
  onContentChanged: "content_changed",
  onDomReady: "domready",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed"
}, an = {
  options(t, e) {
    t.setOptions(e);
  },
  position(t, e) {
    e instanceof google.maps.LatLng ? t.setPosition(e) : t.setPosition(new google.maps.LatLng(e.lat, e.lng));
  },
  visible(t, e) {
    t.setVisible(e);
  },
  zIndex(t, e) {
    t.setZIndex(e);
  }
}, ws = {};
function xs(t) {
  var {
    children: e,
    anchor: n,
    options: i,
    position: s,
    zIndex: r,
    onCloseClick: o,
    onDomReady: l,
    onContentChanged: p,
    onPositionChanged: d,
    onZindexChanged: u,
    onLoad: h,
    onUnmount: g
  } = t, y = ae(A), [c, O] = f(null), [w, P] = f(null), [x, D] = f(null), [b, v] = f(null), [C, k] = f(null), [I, M] = f(null), E = we(null);
  return a(() => {
    y && c !== null && (c.close(), n ? c.open(y, n) : c.getPosition() && c.open(y));
  }, [y, c, n]), a(() => {
    i && c !== null && c.setOptions(i);
  }, [c, i]), a(() => {
    if (s && c !== null) {
      var S = s instanceof google.maps.LatLng ? s : (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        new google.maps.LatLng(s.lat, s.lng)
      );
      c.setPosition(S);
    }
  }, [s]), a(() => {
    typeof r == "number" && c !== null && c.setZIndex(r);
  }, [r]), a(() => {
    c && o && (w !== null && google.maps.event.removeListener(w), P(google.maps.event.addListener(c, "closeclick", o)));
  }, [o]), a(() => {
    c && l && (x !== null && google.maps.event.removeListener(x), D(google.maps.event.addListener(c, "domready", l)));
  }, [l]), a(() => {
    c && p && (b !== null && google.maps.event.removeListener(b), v(google.maps.event.addListener(c, "content_changed", p)));
  }, [p]), a(() => {
    c && d && (C !== null && google.maps.event.removeListener(C), k(google.maps.event.addListener(c, "position_changed", d)));
  }, [d]), a(() => {
    c && u && (I !== null && google.maps.event.removeListener(I), M(google.maps.event.addListener(c, "zindex_changed", u)));
  }, [u]), a(() => {
    if (y) {
      var S = i || ws, {
        position: U
      } = S, $ = yt(S, Cs), T;
      U && !(U instanceof google.maps.LatLng) && (T = new google.maps.LatLng(U.lat, U.lng));
      var B = new mi(Xe(Xe({}, $), T ? {
        position: T
      } : {}));
      E.current = document.createElement("div"), O(B), o && P(google.maps.event.addListener(B, "closeclick", o)), l && D(google.maps.event.addListener(B, "domready", l)), p && v(google.maps.event.addListener(B, "content_changed", p)), d && k(google.maps.event.addListener(B, "position_changed", d)), u && M(google.maps.event.addListener(B, "zindex_changed", u)), B.setContent(E.current), n ? B.open(y, n) : B.getPosition() ? B.open(y) : re(!1, "You must provide either an anchor or a position prop for <InfoBox>."), h && h(B);
    }
    return () => {
      c !== null && (w && google.maps.event.removeListener(w), b && google.maps.event.removeListener(b), x && google.maps.event.removeListener(x), C && google.maps.event.removeListener(C), I && google.maps.event.removeListener(I), g && g(c), c.close());
    };
  }, []), E.current ? at(me.only(e), E.current) : null;
}
oe(xs);
class ks extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "containerElement", null), m(this, "state", {
      infoBox: null
    }), m(this, "open", (e, n) => {
      n ? this.context !== null && e.open(this.context, n) : e.getPosition() ? this.context !== null && e.open(this.context) : re(!1, "You must provide either an anchor or a position prop for <InfoBox>.");
    }), m(this, "setInfoBoxCallback", () => {
      this.state.infoBox !== null && this.containerElement !== null && (this.state.infoBox.setContent(this.containerElement), this.open(this.state.infoBox, this.props.anchor), this.props.onLoad && this.props.onLoad(this.state.infoBox));
    });
  }
  componentDidMount() {
    var e = this.props.options || {}, {
      position: n
    } = e, i = yt(e, Ms), s;
    n && !(n instanceof google.maps.LatLng) && (s = new google.maps.LatLng(n.lat, n.lng));
    var r = new mi(Xe(Xe({}, i), s ? {
      position: s
    } : {}));
    this.containerElement = document.createElement("div"), this.registeredEvents = N({
      updaterMap: an,
      eventMap: on,
      prevProps: {},
      nextProps: this.props,
      instance: r
    }), this.setState({
      infoBox: r
    }, this.setInfoBoxCallback);
  }
  componentDidUpdate(e) {
    var {
      infoBox: n
    } = this.state;
    n !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: an,
      eventMap: on,
      prevProps: e,
      nextProps: this.props,
      instance: n
    }));
  }
  componentWillUnmount() {
    var {
      onUnmount: e
    } = this.props, {
      infoBox: n
    } = this.state;
    n !== null && (e && e(n), V(this.registeredEvents), n.close());
  }
  render() {
    return this.containerElement ? at(me.only(this.props.children), this.containerElement) : null;
  }
}
m(ks, "contextType", A);
var pt, ln;
function Os() {
  return ln || (ln = 1, pt = function t(e, n) {
    if (e === n) return !0;
    if (e && n && typeof e == "object" && typeof n == "object") {
      if (e.constructor !== n.constructor) return !1;
      var i, s, r;
      if (Array.isArray(e)) {
        if (i = e.length, i != n.length) return !1;
        for (s = i; s-- !== 0; ) if (!t(e[s], n[s])) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
      if (r = Object.keys(e), i = r.length, i !== Object.keys(n).length) return !1;
      for (s = i; s-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(n, r[s])) return !1;
      for (s = i; s-- !== 0; ) {
        var o = r[s];
        if (!t(e[o], n[o])) return !1;
      }
      return !0;
    }
    return e !== e && n !== n;
  }), pt;
}
var Ps = Os(), pn = /* @__PURE__ */ li(Ps), un = [Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], ut = 1, Se = 8;
class Lt {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBuffer} data
   */
  static from(e) {
    if (!(e instanceof ArrayBuffer))
      throw new Error("Data must be an instance of ArrayBuffer.");
    var [n, i] = new Uint8Array(e, 0, 2);
    if (n !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    var s = i >> 4;
    if (s !== ut)
      throw new Error("Got v".concat(s, " data when expected v").concat(ut, "."));
    var r = un[i & 15];
    if (!r)
      throw new Error("Unrecognized array type.");
    var [o] = new Uint16Array(e, 2, 1), [l] = new Uint32Array(e, 4, 1);
    return new Lt(l, o, r, e);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBuffer} [data] (For internal use only)
   */
  constructor(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 64, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Float64Array, s = arguments.length > 3 ? arguments[3] : void 0;
    if (isNaN(e) || e < 0) throw new Error("Unpexpected numItems value: ".concat(e, "."));
    this.numItems = +e, this.nodeSize = Math.min(Math.max(+n, 2), 65535), this.ArrayType = i, this.IndexArrayType = e < 65536 ? Uint16Array : Uint32Array;
    var r = un.indexOf(this.ArrayType), o = e * 2 * this.ArrayType.BYTES_PER_ELEMENT, l = e * this.IndexArrayType.BYTES_PER_ELEMENT, p = (8 - l % 8) % 8;
    if (r < 0)
      throw new Error("Unexpected typed array class: ".concat(i, "."));
    s && s instanceof ArrayBuffer ? (this.data = s, this.ids = new this.IndexArrayType(this.data, Se, e), this.coords = new this.ArrayType(this.data, Se + l + p, e * 2), this._pos = e * 2, this._finished = !0) : (this.data = new ArrayBuffer(Se + o + l + p), this.ids = new this.IndexArrayType(this.data, Se, e), this.coords = new this.ArrayType(this.data, Se + l + p, e * 2), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([219, (ut << 4) + r]), new Uint16Array(this.data, 2, 1)[0] = n, new Uint32Array(this.data, 4, 1)[0] = e);
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(e, n) {
    var i = this._pos >> 1;
    return this.ids[i] = i, this.coords[this._pos++] = e, this.coords[this._pos++] = n, i;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    var e = this._pos >> 1;
    if (e !== this.numItems)
      throw new Error("Added ".concat(e, " items when expected ").concat(this.numItems, "."));
    return ft(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(e, n, i, s) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    for (var {
      ids: r,
      coords: o,
      nodeSize: l
    } = this, p = [0, r.length - 1, 0], d = []; p.length; ) {
      var u = p.pop() || 0, h = p.pop() || 0, g = p.pop() || 0;
      if (h - g <= l) {
        for (var y = g; y <= h; y++) {
          var c = o[2 * y], O = o[2 * y + 1];
          c >= e && c <= i && O >= n && O <= s && d.push(r[y]);
        }
        continue;
      }
      var w = g + h >> 1, P = o[2 * w], x = o[2 * w + 1];
      P >= e && P <= i && x >= n && x <= s && d.push(r[w]), (u === 0 ? e <= P : n <= x) && (p.push(g), p.push(w - 1), p.push(1 - u)), (u === 0 ? i >= P : s >= x) && (p.push(w + 1), p.push(h), p.push(1 - u));
    }
    return d;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(e, n, i) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    for (var {
      ids: s,
      coords: r,
      nodeSize: o
    } = this, l = [0, s.length - 1, 0], p = [], d = i * i; l.length; ) {
      var u = l.pop() || 0, h = l.pop() || 0, g = l.pop() || 0;
      if (h - g <= o) {
        for (var y = g; y <= h; y++)
          dn(r[2 * y], r[2 * y + 1], e, n) <= d && p.push(s[y]);
        continue;
      }
      var c = g + h >> 1, O = r[2 * c], w = r[2 * c + 1];
      dn(O, w, e, n) <= d && p.push(s[c]), (u === 0 ? e - i <= O : n - i <= w) && (l.push(g), l.push(c - 1), l.push(1 - u)), (u === 0 ? e + i >= O : n + i >= w) && (l.push(c + 1), l.push(h), l.push(1 - u));
    }
    return p;
  }
}
function ft(t, e, n, i, s, r) {
  if (!(s - i <= n)) {
    var o = i + s >> 1;
    vi(t, e, o, i, s, r), ft(t, e, n, i, o - 1, 1 - r), ft(t, e, n, o + 1, s, 1 - r);
  }
}
function vi(t, e, n, i, s, r) {
  for (; s > i; ) {
    if (s - i > 600) {
      var o = s - i + 1, l = n - i + 1, p = Math.log(o), d = 0.5 * Math.exp(2 * p / 3), u = 0.5 * Math.sqrt(p * d * (o - d) / o) * (l - o / 2 < 0 ? -1 : 1), h = Math.max(i, Math.floor(n - l * d / o + u)), g = Math.min(s, Math.floor(n + (o - l) * d / o + u));
      vi(t, e, n, h, g, r);
    }
    var y = e[2 * n + r], c = i, O = s;
    for (De(t, e, i, n), e[2 * s + r] > y && De(t, e, i, s); c < O; ) {
      for (De(t, e, c, O), c++, O--; e[2 * c + r] < y; ) c++;
      for (; e[2 * O + r] > y; ) O--;
    }
    e[2 * i + r] === y ? De(t, e, i, O) : (O++, De(t, e, O, s)), O <= n && (i = O + 1), n <= O && (s = O - 1);
  }
}
function De(t, e, n, i) {
  dt(t, n, i), dt(e, 2 * n, 2 * i), dt(e, 2 * n + 1, 2 * i + 1);
}
function dt(t, e, n) {
  var i = t[e];
  t[e] = t[n], t[n] = i;
}
function dn(t, e, n, i) {
  var s = t - n, r = e - i;
  return s * s + r * r;
}
var Es = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (t) => t
  // props => ({sum: props.my_value})
}, cn = Math.fround || /* @__PURE__ */ ((t) => (e) => (t[0] = +e, t[0]))(new Float32Array(1)), Le = 2, ye = 3, ct = 4, ve = 5, yi = 6;
class Ss {
  constructor(e) {
    this.options = Object.assign(Object.create(Es), e), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(e) {
    var {
      log: n,
      minZoom: i,
      maxZoom: s
    } = this.options;
    n && console.time("total time");
    var r = "prepare ".concat(e.length, " points");
    n && console.time(r), this.points = e;
    for (var o = [], l = 0; l < e.length; l++) {
      var p = e[l];
      if (p.geometry) {
        var [d, u] = p.geometry.coordinates, h = cn(Ge(d)), g = cn(Ke(u));
        o.push(
          h,
          g,
          // projected point coordinates
          1 / 0,
          // the last zoom the point was processed at
          l,
          // index of the source feature in the original input array
          -1,
          // parent cluster id
          1
          // number of points in a cluster
        ), this.options.reduce && o.push(0);
      }
    }
    var y = this.trees[s + 1] = this._createTree(o);
    n && console.timeEnd(r);
    for (var c = s; c >= i; c--) {
      var O = +Date.now();
      y = this.trees[c] = this._createTree(this._cluster(y, c)), n && console.log("z%d: %d clusters in %dms", c, y.numItems, +Date.now() - O);
    }
    return n && console.timeEnd("total time"), this;
  }
  getClusters(e, n) {
    var i = ((e[0] + 180) % 360 + 360) % 360 - 180, s = Math.max(-90, Math.min(90, e[1])), r = e[2] === 180 ? 180 : ((e[2] + 180) % 360 + 360) % 360 - 180, o = Math.max(-90, Math.min(90, e[3]));
    if (e[2] - e[0] >= 360)
      i = -180, r = 180;
    else if (i > r) {
      var l = this.getClusters([i, s, 180, o], n), p = this.getClusters([-180, s, r, o], n);
      return l.concat(p);
    }
    var d = this.trees[this._limitZoom(n)], u = d.range(Ge(i), Ke(o), Ge(r), Ke(s)), h = d.data, g = [];
    for (var y of u) {
      var c = this.stride * y;
      g.push(h[c + ve] > 1 ? gn(h, c, this.clusterProps) : this.points[h[c + ye]]);
    }
    return g;
  }
  getChildren(e) {
    var n = this._getOriginId(e), i = this._getOriginZoom(e), s = "No cluster with the specified id.", r = this.trees[i];
    if (!r) throw new Error(s);
    var o = r.data;
    if (n * this.stride >= o.length) throw new Error(s);
    var l = this.options.radius / (this.options.extent * Math.pow(2, i - 1)), p = o[n * this.stride], d = o[n * this.stride + 1], u = r.within(p, d, l), h = [];
    for (var g of u) {
      var y = g * this.stride;
      o[y + ct] === e && h.push(o[y + ve] > 1 ? gn(o, y, this.clusterProps) : this.points[o[y + ye]]);
    }
    if (h.length === 0) throw new Error(s);
    return h;
  }
  getLeaves(e, n, i) {
    n = n || 10, i = i || 0;
    var s = [];
    return this._appendLeaves(s, e, n, i, 0), s;
  }
  getTile(e, n, i) {
    var s = this.trees[this._limitZoom(e)], r = Math.pow(2, e), {
      extent: o,
      radius: l
    } = this.options, p = l / o, d = (i - p) / r, u = (i + 1 + p) / r, h = {
      features: []
    };
    return this._addTileFeatures(s.range((n - p) / r, d, (n + 1 + p) / r, u), s.data, n, i, r, h), n === 0 && this._addTileFeatures(s.range(1 - p / r, d, 1, u), s.data, r, i, r, h), n === r - 1 && this._addTileFeatures(s.range(0, d, p / r, u), s.data, -1, i, r, h), h.features.length ? h : null;
  }
  getClusterExpansionZoom(e) {
    for (var n = this._getOriginZoom(e) - 1; n <= this.options.maxZoom; ) {
      var i = this.getChildren(e);
      if (n++, i.length !== 1) break;
      e = i[0].properties.cluster_id;
    }
    return n;
  }
  _appendLeaves(e, n, i, s, r) {
    var o = this.getChildren(n);
    for (var l of o) {
      var p = l.properties;
      if (p && p.cluster ? r + p.point_count <= s ? r += p.point_count : r = this._appendLeaves(e, p.cluster_id, i, s, r) : r < s ? r++ : e.push(l), e.length === i) break;
    }
    return r;
  }
  _createTree(e) {
    for (var n = new Lt(e.length / this.stride | 0, this.options.nodeSize, Float32Array), i = 0; i < e.length; i += this.stride) n.add(e[i], e[i + 1]);
    return n.finish(), n.data = e, n;
  }
  _addTileFeatures(e, n, i, s, r, o) {
    for (var l of e) {
      var p = l * this.stride, d = n[p + ve] > 1, u = void 0, h = void 0, g = void 0;
      if (d)
        u = Li(n, p, this.clusterProps), h = n[p], g = n[p + 1];
      else {
        var y = this.points[n[p + ye]];
        u = y.properties;
        var [c, O] = y.geometry.coordinates;
        h = Ge(c), g = Ke(O);
      }
      var w = {
        type: 1,
        geometry: [[Math.round(this.options.extent * (h * r - i)), Math.round(this.options.extent * (g * r - s))]],
        tags: u
      }, P = void 0;
      d || this.options.generateId ? P = n[p + ye] : P = this.points[n[p + ye]].id, P !== void 0 && (w.id = P), o.features.push(w);
    }
  }
  _limitZoom(e) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+e), this.options.maxZoom + 1));
  }
  _cluster(e, n) {
    for (var {
      radius: i,
      extent: s,
      reduce: r,
      minPoints: o
    } = this.options, l = i / (s * Math.pow(2, n)), p = e.data, d = [], u = this.stride, h = 0; h < p.length; h += u)
      if (!(p[h + Le] <= n)) {
        p[h + Le] = n;
        var g = p[h], y = p[h + 1], c = e.within(p[h], p[h + 1], l), O = p[h + ve], w = O;
        for (var P of c) {
          var x = P * u;
          p[x + Le] > n && (w += p[x + ve]);
        }
        if (w > O && w >= o) {
          var D = g * O, b = y * O, v = void 0, C = -1, k = ((h / u | 0) << 5) + (n + 1) + this.points.length;
          for (var I of c) {
            var M = I * u;
            if (!(p[M + Le] <= n)) {
              p[M + Le] = n;
              var E = p[M + ve];
              D += p[M] * E, b += p[M + 1] * E, p[M + ct] = k, r && (v || (v = this._map(p, h, !0), C = this.clusterProps.length, this.clusterProps.push(v)), r(v, this._map(p, M)));
            }
          }
          p[h + ct] = k, d.push(D / w, b / w, 1 / 0, k, -1, w), r && d.push(C);
        } else {
          for (var S = 0; S < u; S++) d.push(p[h + S]);
          if (w > 1)
            for (var U of c) {
              var $ = U * u;
              if (!(p[$ + Le] <= n)) {
                p[$ + Le] = n;
                for (var T = 0; T < u; T++) d.push(p[$ + T]);
              }
            }
        }
      }
    return d;
  }
  // get index of the point from which the cluster originated
  _getOriginId(e) {
    return e - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(e) {
    return (e - this.points.length) % 32;
  }
  _map(e, n, i) {
    if (e[n + ve] > 1) {
      var s = this.clusterProps[e[n + yi]];
      return i ? Object.assign({}, s) : s;
    }
    var r = this.points[e[n + ye]].properties, o = this.options.map(r);
    return i && o === r ? Object.assign({}, o) : o;
  }
}
function gn(t, e, n) {
  return {
    type: "Feature",
    id: t[e + ye],
    properties: Li(t, e, n),
    geometry: {
      type: "Point",
      coordinates: [Ds(t[e]), Is(t[e + 1])]
    }
  };
}
function Li(t, e, n) {
  var i = t[e + ve], s = i >= 1e4 ? "".concat(Math.round(i / 1e3), "k") : i >= 1e3 ? "".concat(Math.round(i / 100) / 10, "k") : i, r = t[e + yi], o = r === -1 ? {} : Object.assign({}, n[r]);
  return Object.assign(o, {
    cluster: !0,
    cluster_id: t[e + ye],
    point_count: i,
    point_count_abbreviated: s
  });
}
function Ge(t) {
  return t / 360 + 0.5;
}
function Ke(t) {
  var e = Math.sin(t * Math.PI / 180), n = 0.5 - 0.25 * Math.log((1 + e) / (1 - e)) / Math.PI;
  return n < 0 ? 0 : n > 1 ? 1 : n;
}
function Ds(t) {
  return (t - 0.5) * 360;
}
function Is(t) {
  var e = (180 - t * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(e)) / Math.PI - 90;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function _s(t, e) {
  var n = {};
  for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var s = 0, i = Object.getOwnPropertySymbols(t); s < i.length; s++)
    e.indexOf(i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[s]) && (n[i[s]] = t[i[s]]);
  return n;
}
class le {
  static isAdvancedMarkerAvailable(e) {
    return google.maps.marker && e.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(e) {
    return google.maps.marker && e instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(e, n) {
    this.isAdvancedMarker(e) ? e.map = n : e.setMap(n);
  }
  static getPosition(e) {
    if (this.isAdvancedMarker(e)) {
      if (e.position) {
        if (e.position instanceof google.maps.LatLng)
          return e.position;
        if (e.position.lat && e.position.lng)
          return new google.maps.LatLng(e.position.lat, e.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return e.getPosition();
  }
  static getVisible(e) {
    return this.isAdvancedMarker(e) ? !0 : e.getVisible();
  }
}
class mt {
  constructor(e) {
    var {
      markers: n,
      position: i
    } = e;
    this.markers = n, i && (i instanceof google.maps.LatLng ? this._position = i : this._position = new google.maps.LatLng(i));
  }
  get bounds() {
    if (!(this.markers.length === 0 && !this._position)) {
      var e = new google.maps.LatLngBounds(this._position, this._position);
      for (var n of this.markers)
        e.extend(le.getPosition(n));
      return e;
    }
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((e) => le.getVisible(e)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(e) {
    this.markers.push(e);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (le.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
class js {
  constructor(e) {
    var {
      maxZoom: n = 16
    } = e;
    this.maxZoom = n;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop(e) {
    var {
      markers: n
    } = e;
    return Ts(n);
  }
}
var Ts = (t) => {
  var e = t.map((n) => new mt({
    position: le.getPosition(n),
    markers: [n]
  }));
  return e;
};
class Bs extends js {
  constructor(e) {
    var {
      maxZoom: n,
      radius: i = 60
    } = e, s = _s(e, ["maxZoom", "radius"]);
    super({
      maxZoom: n
    }), this.state = {
      zoom: -1
    }, this.superCluster = new Ss(Object.assign({
      maxZoom: this.maxZoom,
      radius: i
    }, s));
  }
  calculate(e) {
    var n = !1, i = {
      zoom: e.map.getZoom()
    };
    if (!pn(e.markers, this.markers)) {
      n = !0, this.markers = [...e.markers];
      var s = this.markers.map((r) => {
        var o = le.getPosition(r), l = [o.lng(), o.lat()];
        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: l
          },
          properties: {
            marker: r
          }
        };
      });
      this.superCluster.load(s);
    }
    return n || (this.state.zoom <= this.maxZoom || i.zoom <= this.maxZoom) && (n = !pn(this.state, i)), this.state = i, n && (this.clusters = this.cluster(e)), {
      clusters: this.clusters,
      changed: n
    };
  }
  cluster(e) {
    var {
      map: n
    } = e;
    return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(n.getZoom())).map((i) => this.transformCluster(i));
  }
  transformCluster(e) {
    var {
      geometry: {
        coordinates: [n, i]
      },
      properties: s
    } = e;
    if (s.cluster)
      return new mt({
        markers: this.superCluster.getLeaves(s.cluster_id, 1 / 0).map((o) => o.properties.marker),
        position: {
          lat: i,
          lng: n
        }
      });
    var r = s.marker;
    return new mt({
      markers: [r],
      position: le.getPosition(r)
    });
  }
}
class Rs {
  constructor(e, n) {
    this.markers = {
      sum: e.length
    };
    var i = n.map((r) => r.count), s = i.reduce((r, o) => r + o, 0);
    this.clusters = {
      count: n.length,
      markers: {
        mean: s / n.length,
        sum: s,
        min: Math.min(...i),
        max: Math.max(...i)
      }
    };
  }
}
class Us {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render(e, n, i) {
    var {
      count: s,
      position: r
    } = e, o = s > Math.max(10, n.clusters.markers.mean) ? "#ff0000" : "#0000ff", l = '<svg fill="'.concat(o, `" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">`).concat(s, `</text>
</svg>`), p = "Cluster of ".concat(s, " markers"), d = Number(google.maps.Marker.MAX_ZINDEX) + s;
    if (le.isAdvancedMarkerAvailable(i)) {
      var u = new DOMParser(), h = u.parseFromString(l, "image/svg+xml").documentElement;
      h.setAttribute("transform", "translate(0 25)");
      var g = {
        map: i,
        position: r,
        zIndex: d,
        title: p,
        content: h
      };
      return new google.maps.marker.AdvancedMarkerElement(g);
    }
    var y = {
      position: r,
      zIndex: d,
      title: p,
      icon: {
        url: "data:image/svg+xml;base64,".concat(btoa(l)),
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(y);
  }
}
function As(t, e) {
  for (var n in e.prototype)
    t.prototype[n] = e.prototype[n];
}
class bt {
  constructor() {
    As(bt, google.maps.OverlayView);
  }
}
var Ie;
(function(t) {
  t.CLUSTERING_BEGIN = "clusteringbegin", t.CLUSTERING_END = "clusteringend", t.CLUSTER_CLICK = "click";
})(Ie || (Ie = {}));
var zs = (t, e, n) => {
  n.fitBounds(e.bounds);
};
class Zs extends bt {
  constructor(e) {
    var {
      map: n,
      markers: i = [],
      algorithmOptions: s = {},
      algorithm: r = new Bs(s),
      renderer: o = new Us(),
      onClusterClick: l = zs
    } = e;
    super(), this.markers = [...i], this.clusters = [], this.algorithm = r, this.renderer = o, this.onClusterClick = l, n && this.setMap(n);
  }
  addMarker(e, n) {
    this.markers.includes(e) || (this.markers.push(e), n || this.render());
  }
  addMarkers(e, n) {
    e.forEach((i) => {
      this.addMarker(i, !0);
    }), n || this.render();
  }
  removeMarker(e, n) {
    var i = this.markers.indexOf(e);
    return i === -1 ? !1 : (le.setMap(e, null), this.markers.splice(i, 1), n || this.render(), !0);
  }
  removeMarkers(e, n) {
    var i = !1;
    return e.forEach((s) => {
      i = this.removeMarker(s, !0) || i;
    }), i && !n && this.render(), i;
  }
  clearMarkers(e) {
    this.markers.length = 0, e || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    var e = this.getMap();
    if (e instanceof google.maps.Map && e.getProjection()) {
      google.maps.event.trigger(this, Ie.CLUSTERING_BEGIN, this);
      var {
        clusters: n,
        changed: i
      } = this.algorithm.calculate({
        markers: this.markers,
        map: e,
        mapCanvasProjection: this.getProjection()
      });
      if (i || i == null) {
        var s = /* @__PURE__ */ new Set();
        for (var r of n)
          r.markers.length == 1 && s.add(r.markers[0]);
        var o = [];
        for (var l of this.clusters)
          l.marker != null && (l.markers.length == 1 ? s.has(l.marker) || le.setMap(l.marker, null) : o.push(l.marker));
        this.clusters = n, this.renderClusters(), requestAnimationFrame(() => o.forEach((p) => le.setMap(p, null)));
      }
      google.maps.event.trigger(this, Ie.CLUSTERING_END, this);
    }
  }
  onAdd() {
    this.idleListener = this.getMap().addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((e) => le.setMap(e, null)), this.clusters.forEach((e) => e.delete()), this.clusters = [];
  }
  renderClusters() {
    var e = new Rs(this.markers, this.clusters), n = this.getMap();
    this.clusters.forEach((i) => {
      i.markers.length === 1 ? i.marker = i.markers[0] : (i.marker = this.renderer.render(i, e, n), i.markers.forEach((s) => le.setMap(s, null)), this.onClusterClick && i.marker.addListener(
        "click",
        /* istanbul ignore next */
        (s) => {
          google.maps.event.trigger(this, Ie.CLUSTER_CLICK, i), this.onClusterClick(s, i, n);
        }
      )), le.setMap(i.marker, n);
    });
  }
}
function hn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function fn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : hn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function Ns(t) {
  var e = pi(), [n, i] = f(null);
  return a(() => {
    if (e && n === null) {
      var s = new Zs(fn(fn({}, t), {}, {
        map: e
      }));
      i(s);
    }
  }, [e]), n;
}
function Vs(t) {
  var {
    children: e,
    options: n
  } = t, i = Ns(n);
  return i !== null ? e(i) : null;
}
oe(Vs);
var mn = {
  onCloseClick: "closeclick",
  onContentChanged: "content_changed",
  onDomReady: "domready",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed"
}, vn = {
  options(t, e) {
    t.setOptions(e);
  },
  position(t, e) {
    t.setPosition(e);
  },
  zIndex(t, e) {
    t.setZIndex(e);
  }
};
function $s(t) {
  var {
    children: e,
    anchor: n,
    options: i,
    position: s,
    zIndex: r,
    onCloseClick: o,
    onDomReady: l,
    onContentChanged: p,
    onPositionChanged: d,
    onZindexChanged: u,
    onLoad: h,
    onUnmount: g
  } = t, y = ae(A), [c, O] = f(null), [w, P] = f(null), [x, D] = f(null), [b, v] = f(null), [C, k] = f(null), [I, M] = f(null), E = we(null);
  return a(() => {
    c !== null && (c.close(), n ? c.open(y, n) : c.getPosition() && c.open(y));
  }, [y, c, n]), a(() => {
    i && c !== null && c.setOptions(i);
  }, [c, i]), a(() => {
    s && c !== null && c.setPosition(s);
  }, [s]), a(() => {
    typeof r == "number" && c !== null && c.setZIndex(r);
  }, [r]), a(() => {
    c && o && (w !== null && google.maps.event.removeListener(w), P(google.maps.event.addListener(c, "closeclick", o)));
  }, [o]), a(() => {
    c && l && (x !== null && google.maps.event.removeListener(x), D(google.maps.event.addListener(c, "domready", l)));
  }, [l]), a(() => {
    c && p && (b !== null && google.maps.event.removeListener(b), v(google.maps.event.addListener(c, "content_changed", p)));
  }, [p]), a(() => {
    c && d && (C !== null && google.maps.event.removeListener(C), k(google.maps.event.addListener(c, "position_changed", d)));
  }, [d]), a(() => {
    c && u && (I !== null && google.maps.event.removeListener(I), M(google.maps.event.addListener(c, "zindex_changed", u)));
  }, [u]), a(() => {
    var S = new google.maps.InfoWindow(i);
    return O(S), E.current = document.createElement("div"), o && P(google.maps.event.addListener(S, "closeclick", o)), l && D(google.maps.event.addListener(S, "domready", l)), p && v(google.maps.event.addListener(S, "content_changed", p)), d && k(google.maps.event.addListener(S, "position_changed", d)), u && M(google.maps.event.addListener(S, "zindex_changed", u)), S.setContent(E.current), s && S.setPosition(s), r && S.setZIndex(r), n ? S.open(y, n) : S.getPosition() ? S.open(y) : re(!1, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."), h && h(S), () => {
      w && google.maps.event.removeListener(w), b && google.maps.event.removeListener(b), x && google.maps.event.removeListener(x), C && google.maps.event.removeListener(C), I && google.maps.event.removeListener(I), g && g(S), S.close();
    };
  }, []), E.current ? at(me.only(e), E.current) : null;
}
oe($s);
class Ws extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "containerElement", null), m(this, "state", {
      infoWindow: null
    }), m(this, "open", (e, n) => {
      n ? e.open(this.context, n) : e.getPosition() ? e.open(this.context) : re(!1, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
    }), m(this, "setInfoWindowCallback", () => {
      this.state.infoWindow !== null && this.containerElement !== null && (this.state.infoWindow.setContent(this.containerElement), this.open(this.state.infoWindow, this.props.anchor), this.props.onLoad && this.props.onLoad(this.state.infoWindow));
    });
  }
  componentDidMount() {
    var e = new google.maps.InfoWindow(this.props.options);
    this.containerElement = document.createElement("div"), this.registeredEvents = N({
      updaterMap: vn,
      eventMap: mn,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(() => ({
      infoWindow: e
    }), this.setInfoWindowCallback);
  }
  componentDidUpdate(e) {
    this.state.infoWindow !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: vn,
      eventMap: mn,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.infoWindow
    }));
  }
  componentWillUnmount() {
    this.state.infoWindow !== null && (V(this.registeredEvents), this.props.onUnmount && this.props.onUnmount(this.state.infoWindow), this.state.infoWindow.close());
  }
  render() {
    return this.containerElement ? at(me.only(this.props.children), this.containerElement) : null;
  }
}
m(Ws, "contextType", A);
function yn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function et(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : yn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var Ln = {
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
}, bn = {
  draggable(t, e) {
    t.setDraggable(e);
  },
  editable(t, e) {
    t.setEditable(e);
  },
  map(t, e) {
    t.setMap(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  path(t, e) {
    t.setPath(e);
  },
  visible(t, e) {
    t.setVisible(e);
  }
}, Fs = {};
function Hs(t) {
  var {
    options: e,
    draggable: n,
    editable: i,
    visible: s,
    path: r,
    onDblClick: o,
    onDragEnd: l,
    onDragStart: p,
    onMouseDown: d,
    onMouseMove: u,
    onMouseOut: h,
    onMouseOver: g,
    onMouseUp: y,
    onRightClick: c,
    onClick: O,
    onDrag: w,
    onLoad: P,
    onUnmount: x
  } = t, D = ae(A), [b, v] = f(null), [C, k] = f(null), [I, M] = f(null), [E, S] = f(null), [U, $] = f(null), [T, B] = f(null), [W, Y] = f(null), [F, q] = f(null), [H, J] = f(null), [Q, j] = f(null), [X, L] = f(null), [ie, te] = f(null);
  return a(() => {
    b !== null && b.setMap(D);
  }, [D]), a(() => {
    typeof e < "u" && b !== null && b.setOptions(e);
  }, [b, e]), a(() => {
    typeof n < "u" && b !== null && b.setDraggable(n);
  }, [b, n]), a(() => {
    typeof i < "u" && b !== null && b.setEditable(i);
  }, [b, i]), a(() => {
    typeof s < "u" && b !== null && b.setVisible(s);
  }, [b, s]), a(() => {
    typeof r < "u" && b !== null && b.setPath(r);
  }, [b, r]), a(() => {
    b && o && (C !== null && google.maps.event.removeListener(C), k(google.maps.event.addListener(b, "dblclick", o)));
  }, [o]), a(() => {
    b && l && (I !== null && google.maps.event.removeListener(I), M(google.maps.event.addListener(b, "dragend", l)));
  }, [l]), a(() => {
    b && p && (E !== null && google.maps.event.removeListener(E), S(google.maps.event.addListener(b, "dragstart", p)));
  }, [p]), a(() => {
    b && d && (U !== null && google.maps.event.removeListener(U), $(google.maps.event.addListener(b, "mousedown", d)));
  }, [d]), a(() => {
    b && u && (T !== null && google.maps.event.removeListener(T), B(google.maps.event.addListener(b, "mousemove", u)));
  }, [u]), a(() => {
    b && h && (W !== null && google.maps.event.removeListener(W), Y(google.maps.event.addListener(b, "mouseout", h)));
  }, [h]), a(() => {
    b && g && (F !== null && google.maps.event.removeListener(F), q(google.maps.event.addListener(b, "mouseover", g)));
  }, [g]), a(() => {
    b && y && (H !== null && google.maps.event.removeListener(H), J(google.maps.event.addListener(b, "mouseup", y)));
  }, [y]), a(() => {
    b && c && (Q !== null && google.maps.event.removeListener(Q), j(google.maps.event.addListener(b, "rightclick", c)));
  }, [c]), a(() => {
    b && O && (X !== null && google.maps.event.removeListener(X), L(google.maps.event.addListener(b, "click", O)));
  }, [O]), a(() => {
    b && w && (ie !== null && google.maps.event.removeListener(ie), te(google.maps.event.addListener(b, "drag", w)));
  }, [w]), a(() => {
    var z = new google.maps.Polyline(et(et({}, e || Fs), {}, {
      map: D
    }));
    return r && z.setPath(r), typeof s < "u" && z.setVisible(s), typeof i < "u" && z.setEditable(i), typeof n < "u" && z.setDraggable(n), o && k(google.maps.event.addListener(z, "dblclick", o)), l && M(google.maps.event.addListener(z, "dragend", l)), p && S(google.maps.event.addListener(z, "dragstart", p)), d && $(google.maps.event.addListener(z, "mousedown", d)), u && B(google.maps.event.addListener(z, "mousemove", u)), h && Y(google.maps.event.addListener(z, "mouseout", h)), g && q(google.maps.event.addListener(z, "mouseover", g)), y && J(google.maps.event.addListener(z, "mouseup", y)), c && j(google.maps.event.addListener(z, "rightclick", c)), O && L(google.maps.event.addListener(z, "click", O)), w && te(google.maps.event.addListener(z, "drag", w)), v(z), P && P(z), () => {
      C !== null && google.maps.event.removeListener(C), I !== null && google.maps.event.removeListener(I), E !== null && google.maps.event.removeListener(E), U !== null && google.maps.event.removeListener(U), T !== null && google.maps.event.removeListener(T), W !== null && google.maps.event.removeListener(W), F !== null && google.maps.event.removeListener(F), H !== null && google.maps.event.removeListener(H), Q !== null && google.maps.event.removeListener(Q), X !== null && google.maps.event.removeListener(X), x && x(z), z.setMap(null);
    };
  }, []), null;
}
oe(Hs);
class Gs extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      polyline: null
    }), m(this, "setPolylineCallback", () => {
      this.state.polyline !== null && this.props.onLoad && this.props.onLoad(this.state.polyline);
    });
  }
  componentDidMount() {
    var e = new google.maps.Polyline(et(et({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = N({
      updaterMap: bn,
      eventMap: Ln,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        polyline: e
      };
    }, this.setPolylineCallback);
  }
  componentDidUpdate(e) {
    this.state.polyline !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: bn,
      eventMap: Ln,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.polyline
    }));
  }
  componentWillUnmount() {
    this.state.polyline !== null && (this.props.onUnmount && this.props.onUnmount(this.state.polyline), V(this.registeredEvents), this.state.polyline.setMap(null));
  }
  render() {
    return null;
  }
}
m(Gs, "contextType", A);
function Cn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Mn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Cn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Cn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var wn = {
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
}, xn = {
  draggable(t, e) {
    t.setDraggable(e);
  },
  editable(t, e) {
    t.setEditable(e);
  },
  map(t, e) {
    t.setMap(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  path(t, e) {
    t.setPath(e);
  },
  paths(t, e) {
    t.setPaths(e);
  },
  visible(t, e) {
    t.setVisible(e);
  }
};
function Ks(t) {
  var {
    options: e,
    draggable: n,
    editable: i,
    visible: s,
    path: r,
    paths: o,
    onDblClick: l,
    onDragEnd: p,
    onDragStart: d,
    onMouseDown: u,
    onMouseMove: h,
    onMouseOut: g,
    onMouseOver: y,
    onMouseUp: c,
    onRightClick: O,
    onClick: w,
    onDrag: P,
    onLoad: x,
    onUnmount: D,
    onEdit: b
  } = t, v = ae(A), [C, k] = f(null), [I, M] = f(null), [E, S] = f(null), [U, $] = f(null), [T, B] = f(null), [W, Y] = f(null), [F, q] = f(null), [H, J] = f(null), [Q, j] = f(null), [X, L] = f(null), [ie, te] = f(null), [z, se] = f(null);
  return a(() => {
    C !== null && C.setMap(v);
  }, [v]), a(() => {
    typeof e < "u" && C !== null && C.setOptions(e);
  }, [C, e]), a(() => {
    typeof n < "u" && C !== null && C.setDraggable(n);
  }, [C, n]), a(() => {
    typeof i < "u" && C !== null && C.setEditable(i);
  }, [C, i]), a(() => {
    typeof s < "u" && C !== null && C.setVisible(s);
  }, [C, s]), a(() => {
    typeof r < "u" && C !== null && C.setPath(r);
  }, [C, r]), a(() => {
    typeof o < "u" && C !== null && C.setPaths(o);
  }, [C, o]), a(() => {
    C && typeof l == "function" && (I !== null && google.maps.event.removeListener(I), M(google.maps.event.addListener(C, "dblclick", l)));
  }, [l]), a(() => {
    C && (google.maps.event.addListener(C.getPath(), "insert_at", () => {
      b == null || b(C);
    }), google.maps.event.addListener(C.getPath(), "set_at", () => {
      b == null || b(C);
    }), google.maps.event.addListener(C.getPath(), "remove_at", () => {
      b == null || b(C);
    }));
  }, [C, b]), a(() => {
    C && typeof p == "function" && (E !== null && google.maps.event.removeListener(E), S(google.maps.event.addListener(C, "dragend", p)));
  }, [p]), a(() => {
    C && typeof d == "function" && (U !== null && google.maps.event.removeListener(U), $(google.maps.event.addListener(C, "dragstart", d)));
  }, [d]), a(() => {
    C && typeof u == "function" && (T !== null && google.maps.event.removeListener(T), B(google.maps.event.addListener(C, "mousedown", u)));
  }, [u]), a(() => {
    C && typeof h == "function" && (W !== null && google.maps.event.removeListener(W), Y(google.maps.event.addListener(C, "mousemove", h)));
  }, [h]), a(() => {
    C && typeof g == "function" && (F !== null && google.maps.event.removeListener(F), q(google.maps.event.addListener(C, "mouseout", g)));
  }, [g]), a(() => {
    C && typeof y == "function" && (H !== null && google.maps.event.removeListener(H), J(google.maps.event.addListener(C, "mouseover", y)));
  }, [y]), a(() => {
    C && typeof c == "function" && (Q !== null && google.maps.event.removeListener(Q), j(google.maps.event.addListener(C, "mouseup", c)));
  }, [c]), a(() => {
    C && typeof O == "function" && (X !== null && google.maps.event.removeListener(X), L(google.maps.event.addListener(C, "rightclick", O)));
  }, [O]), a(() => {
    C && typeof w == "function" && (ie !== null && google.maps.event.removeListener(ie), te(google.maps.event.addListener(C, "click", w)));
  }, [w]), a(() => {
    C && typeof P == "function" && (z !== null && google.maps.event.removeListener(z), se(google.maps.event.addListener(C, "drag", P)));
  }, [P]), a(() => {
    var _ = new google.maps.Polygon(Mn(Mn({}, e), {}, {
      map: v
    }));
    return r && _.setPath(r), o && _.setPaths(o), typeof s < "u" && _.setVisible(s), typeof i < "u" && _.setEditable(i), typeof n < "u" && _.setDraggable(n), l && M(google.maps.event.addListener(_, "dblclick", l)), p && S(google.maps.event.addListener(_, "dragend", p)), d && $(google.maps.event.addListener(_, "dragstart", d)), u && B(google.maps.event.addListener(_, "mousedown", u)), h && Y(google.maps.event.addListener(_, "mousemove", h)), g && q(google.maps.event.addListener(_, "mouseout", g)), y && J(google.maps.event.addListener(_, "mouseover", y)), c && j(google.maps.event.addListener(_, "mouseup", c)), O && L(google.maps.event.addListener(_, "rightclick", O)), w && te(google.maps.event.addListener(_, "click", w)), P && se(google.maps.event.addListener(_, "drag", P)), k(_), x && x(_), () => {
      I !== null && google.maps.event.removeListener(I), E !== null && google.maps.event.removeListener(E), U !== null && google.maps.event.removeListener(U), T !== null && google.maps.event.removeListener(T), W !== null && google.maps.event.removeListener(W), F !== null && google.maps.event.removeListener(F), H !== null && google.maps.event.removeListener(H), Q !== null && google.maps.event.removeListener(Q), X !== null && google.maps.event.removeListener(X), ie !== null && google.maps.event.removeListener(ie), D && D(_), _.setMap(null);
    };
  }, []), null;
}
oe(Ks);
class qs extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []);
  }
  componentDidMount() {
    var e = this.props.options || {};
    this.polygon = new google.maps.Polygon(e), this.polygon.setMap(this.context), this.registeredEvents = N({
      updaterMap: xn,
      eventMap: wn,
      prevProps: {},
      nextProps: this.props,
      instance: this.polygon
    }), this.props.onLoad && this.props.onLoad(this.polygon);
  }
  componentDidUpdate(e) {
    this.polygon && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: xn,
      eventMap: wn,
      prevProps: e,
      nextProps: this.props,
      instance: this.polygon
    }));
  }
  componentWillUnmount() {
    this.polygon && (this.props.onUnmount && this.props.onUnmount(this.polygon), V(this.registeredEvents), this.polygon && this.polygon.setMap(null));
  }
  render() {
    return null;
  }
}
m(qs, "contextType", A);
function kn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function tt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : kn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var On = {
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
}, Pn = {
  bounds(t, e) {
    t.setBounds(e);
  },
  draggable(t, e) {
    t.setDraggable(e);
  },
  editable(t, e) {
    t.setEditable(e);
  },
  map(t, e) {
    t.setMap(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  visible(t, e) {
    t.setVisible(e);
  }
};
function Js(t) {
  var {
    options: e,
    bounds: n,
    draggable: i,
    editable: s,
    visible: r,
    onDblClick: o,
    onDragEnd: l,
    onDragStart: p,
    onMouseDown: d,
    onMouseMove: u,
    onMouseOut: h,
    onMouseOver: g,
    onMouseUp: y,
    onRightClick: c,
    onClick: O,
    onDrag: w,
    onBoundsChanged: P,
    onLoad: x,
    onUnmount: D
  } = t, b = ae(A), [v, C] = f(null), [k, I] = f(null), [M, E] = f(null), [S, U] = f(null), [$, T] = f(null), [B, W] = f(null), [Y, F] = f(null), [q, H] = f(null), [J, Q] = f(null), [j, X] = f(null), [L, ie] = f(null), [te, z] = f(null), [se, _] = f(null);
  return a(() => {
    v !== null && v.setMap(b);
  }, [b]), a(() => {
    typeof e < "u" && v !== null && v.setOptions(e);
  }, [v, e]), a(() => {
    typeof i < "u" && v !== null && v.setDraggable(i);
  }, [v, i]), a(() => {
    typeof s < "u" && v !== null && v.setEditable(s);
  }, [v, s]), a(() => {
    typeof r < "u" && v !== null && v.setVisible(r);
  }, [v, r]), a(() => {
    typeof n < "u" && v !== null && v.setBounds(n);
  }, [v, n]), a(() => {
    v && o && (k !== null && google.maps.event.removeListener(k), I(google.maps.event.addListener(v, "dblclick", o)));
  }, [o]), a(() => {
    v && l && (M !== null && google.maps.event.removeListener(M), E(google.maps.event.addListener(v, "dragend", l)));
  }, [l]), a(() => {
    v && p && (S !== null && google.maps.event.removeListener(S), U(google.maps.event.addListener(v, "dragstart", p)));
  }, [p]), a(() => {
    v && d && ($ !== null && google.maps.event.removeListener($), T(google.maps.event.addListener(v, "mousedown", d)));
  }, [d]), a(() => {
    v && u && (B !== null && google.maps.event.removeListener(B), W(google.maps.event.addListener(v, "mousemove", u)));
  }, [u]), a(() => {
    v && h && (Y !== null && google.maps.event.removeListener(Y), F(google.maps.event.addListener(v, "mouseout", h)));
  }, [h]), a(() => {
    v && g && (q !== null && google.maps.event.removeListener(q), H(google.maps.event.addListener(v, "mouseover", g)));
  }, [g]), a(() => {
    v && y && (J !== null && google.maps.event.removeListener(J), Q(google.maps.event.addListener(v, "mouseup", y)));
  }, [y]), a(() => {
    v && c && (j !== null && google.maps.event.removeListener(j), X(google.maps.event.addListener(v, "rightclick", c)));
  }, [c]), a(() => {
    v && O && (L !== null && google.maps.event.removeListener(L), ie(google.maps.event.addListener(v, "click", O)));
  }, [O]), a(() => {
    v && w && (te !== null && google.maps.event.removeListener(te), z(google.maps.event.addListener(v, "drag", w)));
  }, [w]), a(() => {
    v && P && (se !== null && google.maps.event.removeListener(se), _(google.maps.event.addListener(v, "bounds_changed", P)));
  }, [P]), a(() => {
    var G = new google.maps.Rectangle(tt(tt({}, e), {}, {
      map: b
    }));
    return typeof r < "u" && G.setVisible(r), typeof s < "u" && G.setEditable(s), typeof i < "u" && G.setDraggable(i), typeof n < "u" && G.setBounds(n), o && I(google.maps.event.addListener(G, "dblclick", o)), l && E(google.maps.event.addListener(G, "dragend", l)), p && U(google.maps.event.addListener(G, "dragstart", p)), d && T(google.maps.event.addListener(G, "mousedown", d)), u && W(google.maps.event.addListener(G, "mousemove", u)), h && F(google.maps.event.addListener(G, "mouseout", h)), g && H(google.maps.event.addListener(G, "mouseover", g)), y && Q(google.maps.event.addListener(G, "mouseup", y)), c && X(google.maps.event.addListener(G, "rightclick", c)), O && ie(google.maps.event.addListener(G, "click", O)), w && z(google.maps.event.addListener(G, "drag", w)), P && _(google.maps.event.addListener(G, "bounds_changed", P)), C(G), x && x(G), () => {
      k !== null && google.maps.event.removeListener(k), M !== null && google.maps.event.removeListener(M), S !== null && google.maps.event.removeListener(S), $ !== null && google.maps.event.removeListener($), B !== null && google.maps.event.removeListener(B), Y !== null && google.maps.event.removeListener(Y), q !== null && google.maps.event.removeListener(q), J !== null && google.maps.event.removeListener(J), j !== null && google.maps.event.removeListener(j), L !== null && google.maps.event.removeListener(L), te !== null && google.maps.event.removeListener(te), se !== null && google.maps.event.removeListener(se), D && D(G), G.setMap(null);
    };
  }, []), null;
}
oe(Js);
class Ys extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      rectangle: null
    }), m(this, "setRectangleCallback", () => {
      this.state.rectangle !== null && this.props.onLoad && this.props.onLoad(this.state.rectangle);
    });
  }
  componentDidMount() {
    var e = new google.maps.Rectangle(tt(tt({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = N({
      updaterMap: Pn,
      eventMap: On,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        rectangle: e
      };
    }, this.setRectangleCallback);
  }
  componentDidUpdate(e) {
    this.state.rectangle !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Pn,
      eventMap: On,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.rectangle
    }));
  }
  componentWillUnmount() {
    this.state.rectangle !== null && (this.props.onUnmount && this.props.onUnmount(this.state.rectangle), V(this.registeredEvents), this.state.rectangle.setMap(null));
  }
  render() {
    return null;
  }
}
m(Ys, "contextType", A);
function En(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function nt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? En(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : En(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var Sn = {
  onCenterChanged: "center_changed",
  onRadiusChanged: "radius_changed",
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
}, Dn = {
  center(t, e) {
    t.setCenter(e);
  },
  draggable(t, e) {
    t.setDraggable(e);
  },
  editable(t, e) {
    t.setEditable(e);
  },
  map(t, e) {
    t.setMap(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  radius(t, e) {
    t.setRadius(e);
  },
  visible(t, e) {
    t.setVisible(e);
  }
}, Qs = {};
function Xs(t) {
  var {
    options: e,
    center: n,
    radius: i,
    draggable: s,
    editable: r,
    visible: o,
    onDblClick: l,
    onDragEnd: p,
    onDragStart: d,
    onMouseDown: u,
    onMouseMove: h,
    onMouseOut: g,
    onMouseOver: y,
    onMouseUp: c,
    onRightClick: O,
    onClick: w,
    onDrag: P,
    onCenterChanged: x,
    onRadiusChanged: D,
    onLoad: b,
    onUnmount: v
  } = t, C = ae(A), [k, I] = f(null), [M, E] = f(null), [S, U] = f(null), [$, T] = f(null), [B, W] = f(null), [Y, F] = f(null), [q, H] = f(null), [J, Q] = f(null), [j, X] = f(null), [L, ie] = f(null), [te, z] = f(null), [se, _] = f(null), [G, de] = f(null), [ge, ke] = f(null);
  return a(() => {
    k !== null && k.setMap(C);
  }, [C]), a(() => {
    typeof e < "u" && k !== null && k.setOptions(e);
  }, [k, e]), a(() => {
    typeof s < "u" && k !== null && k.setDraggable(s);
  }, [k, s]), a(() => {
    typeof r < "u" && k !== null && k.setEditable(r);
  }, [k, r]), a(() => {
    typeof o < "u" && k !== null && k.setVisible(o);
  }, [k, o]), a(() => {
    typeof i == "number" && k !== null && k.setRadius(i);
  }, [k, i]), a(() => {
    typeof n < "u" && k !== null && k.setCenter(n);
  }, [k, n]), a(() => {
    k && l && (M !== null && google.maps.event.removeListener(M), E(google.maps.event.addListener(k, "dblclick", l)));
  }, [l]), a(() => {
    k && p && (S !== null && google.maps.event.removeListener(S), U(google.maps.event.addListener(k, "dragend", p)));
  }, [p]), a(() => {
    k && d && ($ !== null && google.maps.event.removeListener($), T(google.maps.event.addListener(k, "dragstart", d)));
  }, [d]), a(() => {
    k && u && (B !== null && google.maps.event.removeListener(B), W(google.maps.event.addListener(k, "mousedown", u)));
  }, [u]), a(() => {
    k && h && (Y !== null && google.maps.event.removeListener(Y), F(google.maps.event.addListener(k, "mousemove", h)));
  }, [h]), a(() => {
    k && g && (q !== null && google.maps.event.removeListener(q), H(google.maps.event.addListener(k, "mouseout", g)));
  }, [g]), a(() => {
    k && y && (J !== null && google.maps.event.removeListener(J), Q(google.maps.event.addListener(k, "mouseover", y)));
  }, [y]), a(() => {
    k && c && (j !== null && google.maps.event.removeListener(j), X(google.maps.event.addListener(k, "mouseup", c)));
  }, [c]), a(() => {
    k && O && (L !== null && google.maps.event.removeListener(L), ie(google.maps.event.addListener(k, "rightclick", O)));
  }, [O]), a(() => {
    k && w && (te !== null && google.maps.event.removeListener(te), z(google.maps.event.addListener(k, "click", w)));
  }, [w]), a(() => {
    k && P && (se !== null && google.maps.event.removeListener(se), _(google.maps.event.addListener(k, "drag", P)));
  }, [P]), a(() => {
    k && x && (G !== null && google.maps.event.removeListener(G), de(google.maps.event.addListener(k, "center_changed", x)));
  }, [w]), a(() => {
    k && D && (ge !== null && google.maps.event.removeListener(ge), ke(google.maps.event.addListener(k, "radius_changed", D)));
  }, [D]), a(() => {
    var ee = new google.maps.Circle(nt(nt({}, e || Qs), {}, {
      map: C
    }));
    return typeof i == "number" && ee.setRadius(i), typeof n < "u" && ee.setCenter(n), typeof i == "number" && ee.setRadius(i), typeof o < "u" && ee.setVisible(o), typeof r < "u" && ee.setEditable(r), typeof s < "u" && ee.setDraggable(s), l && E(google.maps.event.addListener(ee, "dblclick", l)), p && U(google.maps.event.addListener(ee, "dragend", p)), d && T(google.maps.event.addListener(ee, "dragstart", d)), u && W(google.maps.event.addListener(ee, "mousedown", u)), h && F(google.maps.event.addListener(ee, "mousemove", h)), g && H(google.maps.event.addListener(ee, "mouseout", g)), y && Q(google.maps.event.addListener(ee, "mouseover", y)), c && X(google.maps.event.addListener(ee, "mouseup", c)), O && ie(google.maps.event.addListener(ee, "rightclick", O)), w && z(google.maps.event.addListener(ee, "click", w)), P && _(google.maps.event.addListener(ee, "drag", P)), x && de(google.maps.event.addListener(ee, "center_changed", x)), D && ke(google.maps.event.addListener(ee, "radius_changed", D)), I(ee), b && b(ee), () => {
      M !== null && google.maps.event.removeListener(M), S !== null && google.maps.event.removeListener(S), $ !== null && google.maps.event.removeListener($), B !== null && google.maps.event.removeListener(B), Y !== null && google.maps.event.removeListener(Y), q !== null && google.maps.event.removeListener(q), J !== null && google.maps.event.removeListener(J), j !== null && google.maps.event.removeListener(j), L !== null && google.maps.event.removeListener(L), te !== null && google.maps.event.removeListener(te), G !== null && google.maps.event.removeListener(G), ge !== null && google.maps.event.removeListener(ge), v && v(ee), ee.setMap(null);
    };
  }, []), null;
}
oe(Xs);
class er extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      circle: null
    }), m(this, "setCircleCallback", () => {
      this.state.circle !== null && this.props.onLoad && this.props.onLoad(this.state.circle);
    });
  }
  componentDidMount() {
    var e = new google.maps.Circle(nt(nt({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = N({
      updaterMap: Dn,
      eventMap: Sn,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        circle: e
      };
    }, this.setCircleCallback);
  }
  componentDidUpdate(e) {
    this.state.circle !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Dn,
      eventMap: Sn,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.circle
    }));
  }
  componentWillUnmount() {
    if (this.state.circle !== null) {
      var e;
      this.props.onUnmount && this.props.onUnmount(this.state.circle), V(this.registeredEvents), (e = this.state.circle) === null || e === void 0 || e.setMap(null);
    }
  }
  render() {
    return null;
  }
}
m(er, "contextType", A);
function In(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function it(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? In(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : In(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var _n = {
  onClick: "click",
  onDblClick: "dblclick",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onAddFeature: "addfeature",
  onRemoveFeature: "removefeature",
  onRemoveProperty: "removeproperty",
  onSetGeometry: "setgeometry",
  onSetProperty: "setproperty"
}, jn = {
  add(t, e) {
    t.add(e);
  },
  addgeojson(t, e, n) {
    t.addGeoJson(e, n);
  },
  contains(t, e) {
    t.contains(e);
  },
  foreach(t, e) {
    t.forEach(e);
  },
  loadgeojson(t, e, n, i) {
    t.loadGeoJson(e, n, i);
  },
  overridestyle(t, e, n) {
    t.overrideStyle(e, n);
  },
  remove(t, e) {
    t.remove(e);
  },
  revertstyle(t, e) {
    t.revertStyle(e);
  },
  controlposition(t, e) {
    t.setControlPosition(e);
  },
  controls(t, e) {
    t.setControls(e);
  },
  drawingmode(t, e) {
    t.setDrawingMode(e);
  },
  map(t, e) {
    t.setMap(e);
  },
  style(t, e) {
    t.setStyle(e);
  },
  togeojson(t, e) {
    t.toGeoJson(e);
  }
};
function tr(t) {
  var {
    options: e,
    onClick: n,
    onDblClick: i,
    onMouseDown: s,
    onMouseMove: r,
    onMouseOut: o,
    onMouseOver: l,
    onMouseUp: p,
    onRightClick: d,
    onAddFeature: u,
    onRemoveFeature: h,
    onRemoveProperty: g,
    onSetGeometry: y,
    onSetProperty: c,
    onLoad: O,
    onUnmount: w
  } = t, P = ae(A), [x, D] = f(null), [b, v] = f(null), [C, k] = f(null), [I, M] = f(null), [E, S] = f(null), [U, $] = f(null), [T, B] = f(null), [W, Y] = f(null), [F, q] = f(null), [H, J] = f(null), [Q, j] = f(null), [X, L] = f(null), [ie, te] = f(null), [z, se] = f(null);
  return a(() => {
    x !== null && x.setMap(P);
  }, [P]), a(() => {
    x && i && (b !== null && google.maps.event.removeListener(b), v(google.maps.event.addListener(x, "dblclick", i)));
  }, [i]), a(() => {
    x && s && (C !== null && google.maps.event.removeListener(C), k(google.maps.event.addListener(x, "mousedown", s)));
  }, [s]), a(() => {
    x && r && (I !== null && google.maps.event.removeListener(I), M(google.maps.event.addListener(x, "mousemove", r)));
  }, [r]), a(() => {
    x && o && (E !== null && google.maps.event.removeListener(E), S(google.maps.event.addListener(x, "mouseout", o)));
  }, [o]), a(() => {
    x && l && (U !== null && google.maps.event.removeListener(U), $(google.maps.event.addListener(x, "mouseover", l)));
  }, [l]), a(() => {
    x && p && (T !== null && google.maps.event.removeListener(T), B(google.maps.event.addListener(x, "mouseup", p)));
  }, [p]), a(() => {
    x && d && (W !== null && google.maps.event.removeListener(W), Y(google.maps.event.addListener(x, "rightclick", d)));
  }, [d]), a(() => {
    x && n && (F !== null && google.maps.event.removeListener(F), q(google.maps.event.addListener(x, "click", n)));
  }, [n]), a(() => {
    x && u && (H !== null && google.maps.event.removeListener(H), J(google.maps.event.addListener(x, "addfeature", u)));
  }, [u]), a(() => {
    x && h && (Q !== null && google.maps.event.removeListener(Q), j(google.maps.event.addListener(x, "removefeature", h)));
  }, [h]), a(() => {
    x && g && (X !== null && google.maps.event.removeListener(X), L(google.maps.event.addListener(x, "removeproperty", g)));
  }, [g]), a(() => {
    x && y && (ie !== null && google.maps.event.removeListener(ie), te(google.maps.event.addListener(x, "setgeometry", y)));
  }, [y]), a(() => {
    x && c && (z !== null && google.maps.event.removeListener(z), se(google.maps.event.addListener(x, "setproperty", c)));
  }, [c]), a(() => {
    if (P !== null) {
      var _ = new google.maps.Data(it(it({}, e), {}, {
        map: P
      }));
      i && v(google.maps.event.addListener(_, "dblclick", i)), s && k(google.maps.event.addListener(_, "mousedown", s)), r && M(google.maps.event.addListener(_, "mousemove", r)), o && S(google.maps.event.addListener(_, "mouseout", o)), l && $(google.maps.event.addListener(_, "mouseover", l)), p && B(google.maps.event.addListener(_, "mouseup", p)), d && Y(google.maps.event.addListener(_, "rightclick", d)), n && q(google.maps.event.addListener(_, "click", n)), u && J(google.maps.event.addListener(_, "addfeature", u)), h && j(google.maps.event.addListener(_, "removefeature", h)), g && L(google.maps.event.addListener(_, "removeproperty", g)), y && te(google.maps.event.addListener(_, "setgeometry", y)), c && se(google.maps.event.addListener(_, "setproperty", c)), D(_), O && O(_);
    }
    return () => {
      x && (b !== null && google.maps.event.removeListener(b), C !== null && google.maps.event.removeListener(C), I !== null && google.maps.event.removeListener(I), E !== null && google.maps.event.removeListener(E), U !== null && google.maps.event.removeListener(U), T !== null && google.maps.event.removeListener(T), W !== null && google.maps.event.removeListener(W), F !== null && google.maps.event.removeListener(F), H !== null && google.maps.event.removeListener(H), Q !== null && google.maps.event.removeListener(Q), X !== null && google.maps.event.removeListener(X), ie !== null && google.maps.event.removeListener(ie), z !== null && google.maps.event.removeListener(z), w && w(x), x.setMap(null));
    };
  }, []), null;
}
oe(tr);
class nr extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      data: null
    }), m(this, "setDataCallback", () => {
      this.state.data !== null && this.props.onLoad && this.props.onLoad(this.state.data);
    });
  }
  componentDidMount() {
    if (this.context !== null) {
      var e = new google.maps.Data(it(it({}, this.props.options), {}, {
        map: this.context
      }));
      this.registeredEvents = N({
        updaterMap: jn,
        eventMap: _n,
        prevProps: {},
        nextProps: this.props,
        instance: e
      }), this.setState(() => ({
        data: e
      }), this.setDataCallback);
    }
  }
  componentDidUpdate(e) {
    this.state.data !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: jn,
      eventMap: _n,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.data
    }));
  }
  componentWillUnmount() {
    this.state.data !== null && (this.props.onUnmount && this.props.onUnmount(this.state.data), V(this.registeredEvents), this.state.data && this.state.data.setMap(null));
  }
  render() {
    return null;
  }
}
m(nr, "contextType", A);
function Tn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Bn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Tn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Tn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var Rn = {
  onClick: "click",
  onDefaultViewportChanged: "defaultviewport_changed",
  onStatusChanged: "status_changed"
}, Un = {
  options(t, e) {
    t.setOptions(e);
  },
  url(t, e) {
    t.setUrl(e);
  },
  zIndex(t, e) {
    t.setZIndex(e);
  }
};
class ir extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      kmlLayer: null
    }), m(this, "setKmlLayerCallback", () => {
      this.state.kmlLayer !== null && this.props.onLoad && this.props.onLoad(this.state.kmlLayer);
    });
  }
  componentDidMount() {
    var e = new google.maps.KmlLayer(Bn(Bn({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = N({
      updaterMap: Un,
      eventMap: Rn,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        kmlLayer: e
      };
    }, this.setKmlLayerCallback);
  }
  componentDidUpdate(e) {
    this.state.kmlLayer !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Un,
      eventMap: Rn,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.kmlLayer
    }));
  }
  componentWillUnmount() {
    this.state.kmlLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.kmlLayer), V(this.registeredEvents), this.state.kmlLayer.setMap(null));
  }
  render() {
    return null;
  }
}
m(ir, "contextType", A);
function bi(t, e) {
  return typeof e == "function" ? e(t.offsetWidth, t.offsetHeight) : {
    x: 0,
    y: 0
  };
}
function sr(t, e) {
  return new e(t.lat, t.lng);
}
function rr(t, e) {
  return new e(new google.maps.LatLng(t.ne.lat, t.ne.lng), new google.maps.LatLng(t.sw.lat, t.sw.lng));
}
function or(t, e, n) {
  return t instanceof e ? t : n(t, e);
}
function ar(t, e, n) {
  return t instanceof e ? t : n(t, e);
}
function lr(t, e, n) {
  var i = t && t.fromLatLngToDivPixel(n.getNorthEast()), s = t && t.fromLatLngToDivPixel(n.getSouthWest());
  return i && s ? {
    left: "".concat(s.x + e.x, "px"),
    top: "".concat(i.y + e.y, "px"),
    width: "".concat(i.x - s.x - e.x, "px"),
    height: "".concat(s.y - i.y - e.y, "px")
  } : {
    left: "-9999px",
    top: "-9999px"
  };
}
function pr(t, e, n) {
  var i = t && t.fromLatLngToDivPixel(n);
  if (i) {
    var {
      x: s,
      y: r
    } = i;
    return {
      left: "".concat(s + e.x, "px"),
      top: "".concat(r + e.y, "px")
    };
  }
  return {
    left: "-9999px",
    top: "-9999px"
  };
}
function Ci(t, e, n, i) {
  return n !== void 0 ? lr(t, e, ar(n, google.maps.LatLngBounds, rr)) : pr(t, e, or(i, google.maps.LatLng, sr));
}
function ur(t, e) {
  return t.left === e.left && t.top === e.top && t.width === e.height && t.height === e.height;
}
function An(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function dr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? An(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : An(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function cr(t, e, n, i, s) {
  class r extends google.maps.OverlayView {
    constructor(l, p, d, u) {
      super(), this.container = l, this.pane = p, this.position = d, this.bounds = u;
    }
    onAdd() {
      var l, p = (l = this.getPanes()) === null || l === void 0 ? void 0 : l[this.pane];
      p == null || p.appendChild(this.container);
    }
    draw() {
      var l = this.getProjection(), p = dr({}, this.container ? bi(this.container, s) : {
        x: 0,
        y: 0
      }), d = Ci(l, p, this.bounds, this.position);
      for (var [u, h] of Object.entries(d))
        this.container.style[u] = h;
    }
    onRemove() {
      this.container.parentNode !== null && this.container.parentNode.removeChild(this.container);
    }
  }
  return new r(t, e, n, i);
}
function zn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function gr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? zn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : zn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function Zn(t) {
  if (!t)
    return "";
  var e = t instanceof google.maps.LatLng ? t : new google.maps.LatLng(t.lat, t.lng);
  return e + "";
}
function Nn(t) {
  if (!t)
    return "";
  var e = t instanceof google.maps.LatLngBounds ? t : new google.maps.LatLngBounds(new google.maps.LatLng(t.south, t.east), new google.maps.LatLng(t.north, t.west));
  return e + "";
}
function hr(t) {
  var {
    position: e,
    bounds: n,
    mapPaneName: i,
    zIndex: s,
    onLoad: r,
    onUnmount: o,
    getPixelPositionOffset: l,
    children: p
  } = t, d = ae(A), u = qe(() => {
    var g = document.createElement("div");
    return g.style.position = "absolute", g;
  }, []), h = qe(() => cr(u, i, e, n, l), [u, i, e, n]);
  return a(() => (r == null || r(h), h == null || h.setMap(d), () => {
    o == null || o(h), h == null || h.setMap(null);
  }), [d, h]), a(() => {
    u.style.zIndex = "".concat(s);
  }, [s, u]), oi.createPortal(p, u);
}
oe(hr);
class xe extends ne {
  constructor(e) {
    super(e), m(this, "state", {
      paneEl: null,
      containerStyle: {
        // set initial position
        position: "absolute"
      }
    }), m(this, "updatePane", () => {
      var i = this.props.mapPaneName, s = this.overlayView.getPanes();
      re(!!i, "OverlayView requires props.mapPaneName but got %s", i), s ? this.setState({
        paneEl: s[i]
      }) : this.setState({
        paneEl: null
      });
    }), m(this, "onAdd", () => {
      var i, s;
      this.updatePane(), (i = (s = this.props).onLoad) === null || i === void 0 || i.call(s, this.overlayView);
    }), m(this, "onPositionElement", () => {
      var i = this.overlayView.getProjection(), s = gr({
        x: 0,
        y: 0
      }, this.containerRef.current ? bi(this.containerRef.current, this.props.getPixelPositionOffset) : {}), r = Ci(i, s, this.props.bounds, this.props.position);
      if (!ur(r, {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        left: this.state.containerStyle.left,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        top: this.state.containerStyle.top,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        width: this.state.containerStyle.width,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        height: this.state.containerStyle.height
      })) {
        var o, l, p, d;
        this.setState({
          containerStyle: {
            top: (o = r.top) !== null && o !== void 0 ? o : 0,
            left: (l = r.left) !== null && l !== void 0 ? l : 0,
            width: (p = r.width) !== null && p !== void 0 ? p : 0,
            height: (d = r.height) !== null && d !== void 0 ? d : 0,
            position: "absolute"
          }
        });
      }
    }), m(this, "draw", () => {
      this.onPositionElement();
    }), m(this, "onRemove", () => {
      var i, s;
      this.setState(() => ({
        paneEl: null
      })), (i = (s = this.props).onUnmount) === null || i === void 0 || i.call(s, this.overlayView);
    }), this.containerRef = ot();
    var n = new google.maps.OverlayView();
    n.onAdd = this.onAdd, n.draw = this.draw, n.onRemove = this.onRemove, this.overlayView = n;
  }
  componentDidMount() {
    this.overlayView.setMap(this.context);
  }
  componentDidUpdate(e) {
    var n = Zn(e.position), i = Zn(this.props.position), s = Nn(e.bounds), r = Nn(this.props.bounds);
    (n !== i || s !== r) && this.overlayView.draw(), e.mapPaneName !== this.props.mapPaneName && this.updatePane();
  }
  componentWillUnmount() {
    this.overlayView.setMap(null);
  }
  render() {
    var e = this.state.paneEl;
    return e ? oi.createPortal(Z("div", {
      ref: this.containerRef,
      style: this.state.containerStyle,
      children: me.only(this.props.children)
    }), e) : null;
  }
}
m(xe, "FLOAT_PANE", "floatPane");
m(xe, "MAP_PANE", "mapPane");
m(xe, "MARKER_LAYER", "markerLayer");
m(xe, "OVERLAY_LAYER", "overlayLayer");
m(xe, "OVERLAY_MOUSE_TARGET", "overlayMouseTarget");
m(xe, "contextType", A);
function fr() {
}
function Vn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function $n(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Vn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Vn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var Wn = {
  onDblClick: "dblclick",
  onClick: "click"
}, Fn = {
  opacity(t, e) {
    t.setOpacity(e);
  }
};
function mr(t) {
  var {
    url: e,
    bounds: n,
    options: i,
    visible: s
  } = t, r = ae(A), o = new google.maps.LatLngBounds(new google.maps.LatLng(n.south, n.west), new google.maps.LatLng(n.north, n.east)), l = qe(() => new google.maps.GroundOverlay(e, o, i), []);
  return a(() => {
    l !== null && l.setMap(r);
  }, [r]), a(() => {
    typeof e < "u" && l !== null && (l.set("url", e), l.setMap(r));
  }, [l, e]), a(() => {
    typeof s < "u" && l !== null && l.setOpacity(s ? 1 : 0);
  }, [l, s]), a(() => {
    var p = new google.maps.LatLngBounds(new google.maps.LatLng(n.south, n.west), new google.maps.LatLng(n.north, n.east));
    typeof n < "u" && l !== null && (l.set("bounds", p), l.setMap(r));
  }, [l, n]), null;
}
oe(mr);
class Mi extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      groundOverlay: null
    }), m(this, "setGroundOverlayCallback", () => {
      this.state.groundOverlay !== null && this.props.onLoad && this.props.onLoad(this.state.groundOverlay);
    });
  }
  componentDidMount() {
    re(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
    var e = new google.maps.GroundOverlay(this.props.url, this.props.bounds, $n($n({}, this.props.options), {}, {
      map: this.context
    }));
    this.registeredEvents = N({
      updaterMap: Fn,
      eventMap: Wn,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        groundOverlay: e
      };
    }, this.setGroundOverlayCallback);
  }
  componentDidUpdate(e) {
    this.state.groundOverlay !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Fn,
      eventMap: Wn,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.groundOverlay
    }));
  }
  componentWillUnmount() {
    this.state.groundOverlay && (this.props.onUnmount && this.props.onUnmount(this.state.groundOverlay), this.state.groundOverlay.setMap(null));
  }
  render() {
    return null;
  }
}
m(Mi, "defaultProps", {
  onLoad: fr
});
m(Mi, "contextType", A);
function Hn(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function st(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Hn(Object(n), !0).forEach(function(i) {
      m(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Hn(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var Gn = {}, Kn = {
  data(t, e) {
    t.setData(e);
  },
  map(t, e) {
    t.setMap(e);
  },
  options(t, e) {
    t.setOptions(e);
  }
};
function vr(t) {
  var {
    data: e,
    onLoad: n,
    onUnmount: i,
    options: s
  } = t, r = ae(A), [o, l] = f(null);
  return a(() => {
    google.maps.visualization || re(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} in useJsApiScript? %s', google.maps.visualization);
  }, []), a(() => {
    re(!!e, "data property is required in HeatmapLayer %s", e);
  }, [e]), a(() => {
    o !== null && o.setMap(r);
  }, [r]), a(() => {
    s && o !== null && o.setOptions(s);
  }, [o, s]), a(() => {
    var p = new google.maps.visualization.HeatmapLayer(st(st({}, s), {}, {
      data: e,
      map: r
    }));
    return l(p), n && n(p), () => {
      o !== null && (i && i(o), o.setMap(null));
    };
  }, []), null;
}
oe(vr);
class yr extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      heatmapLayer: null
    }), m(this, "setHeatmapLayerCallback", () => {
      this.state.heatmapLayer !== null && this.props.onLoad && this.props.onLoad(this.state.heatmapLayer);
    });
  }
  componentDidMount() {
    re(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization), re(!!this.props.data, "data property is required in HeatmapLayer %s", this.props.data);
    var e = new google.maps.visualization.HeatmapLayer(st(st({}, this.props.options), {}, {
      data: this.props.data,
      map: this.context
    }));
    this.registeredEvents = N({
      updaterMap: Kn,
      eventMap: Gn,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        heatmapLayer: e
      };
    }, this.setHeatmapLayerCallback);
  }
  componentDidUpdate(e) {
    V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Kn,
      eventMap: Gn,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.heatmapLayer
    });
  }
  componentWillUnmount() {
    this.state.heatmapLayer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.heatmapLayer), V(this.registeredEvents), this.state.heatmapLayer.setMap(null));
  }
  render() {
    return null;
  }
}
m(yr, "contextType", A);
var qn = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed"
}, Jn = {
  register(t, e, n) {
    t.registerPanoProvider(e, n);
  },
  links(t, e) {
    t.setLinks(e);
  },
  motionTracking(t, e) {
    t.setMotionTracking(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  pano(t, e) {
    t.setPano(e);
  },
  position(t, e) {
    t.setPosition(e);
  },
  pov(t, e) {
    t.setPov(e);
  },
  visible(t, e) {
    t.setVisible(e);
  },
  zoom(t, e) {
    t.setZoom(e);
  }
};
class Lr extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      streetViewPanorama: null
    }), m(this, "setStreetViewPanoramaCallback", () => {
      this.state.streetViewPanorama !== null && this.props.onLoad && this.props.onLoad(this.state.streetViewPanorama);
    });
  }
  componentDidMount() {
    var e, n, i = (e = (n = this.context) === null || n === void 0 ? void 0 : n.getStreetView()) !== null && e !== void 0 ? e : null;
    this.registeredEvents = N({
      updaterMap: Jn,
      eventMap: qn,
      prevProps: {},
      nextProps: this.props,
      instance: i
    }), this.setState(() => ({
      streetViewPanorama: i
    }), this.setStreetViewPanoramaCallback);
  }
  componentDidUpdate(e) {
    this.state.streetViewPanorama !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Jn,
      eventMap: qn,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.streetViewPanorama
    }));
  }
  componentWillUnmount() {
    this.state.streetViewPanorama !== null && (this.props.onUnmount && this.props.onUnmount(this.state.streetViewPanorama), V(this.registeredEvents), this.state.streetViewPanorama.setVisible(!1));
  }
  render() {
    return null;
  }
}
m(Lr, "contextType", A);
class br extends ne {
  constructor() {
    super(...arguments), m(this, "state", {
      streetViewService: null
    }), m(this, "setStreetViewServiceCallback", () => {
      this.state.streetViewService !== null && this.props.onLoad && this.props.onLoad(this.state.streetViewService);
    });
  }
  componentDidMount() {
    var e = new google.maps.StreetViewService();
    this.setState(function() {
      return {
        streetViewService: e
      };
    }, this.setStreetViewServiceCallback);
  }
  componentWillUnmount() {
    this.state.streetViewService !== null && this.props.onUnmount && this.props.onUnmount(this.state.streetViewService);
  }
  render() {
    return null;
  }
}
m(br, "contextType", A);
var Yn = {
  onDirectionsChanged: "directions_changed"
}, Qn = {
  directions(t, e) {
    t.setDirections(e);
  },
  map(t, e) {
    t.setMap(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  panel(t, e) {
    t.setPanel(e);
  },
  routeIndex(t, e) {
    t.setRouteIndex(e);
  }
};
class Cr extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "state", {
      directionsRenderer: null
    }), m(this, "setDirectionsRendererCallback", () => {
      this.state.directionsRenderer !== null && (this.state.directionsRenderer.setMap(this.context), this.props.onLoad && this.props.onLoad(this.state.directionsRenderer));
    });
  }
  componentDidMount() {
    var e = new google.maps.DirectionsRenderer(this.props.options);
    this.registeredEvents = N({
      updaterMap: Qn,
      eventMap: Yn,
      prevProps: {},
      nextProps: this.props,
      instance: e
    }), this.setState(function() {
      return {
        directionsRenderer: e
      };
    }, this.setDirectionsRendererCallback);
  }
  componentDidUpdate(e) {
    this.state.directionsRenderer !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: Qn,
      eventMap: Yn,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.directionsRenderer
    }));
  }
  componentWillUnmount() {
    this.state.directionsRenderer !== null && (this.props.onUnmount && this.props.onUnmount(this.state.directionsRenderer), V(this.registeredEvents), this.state.directionsRenderer && this.state.directionsRenderer.setMap(null));
  }
  render() {
    return null;
  }
}
m(Cr, "contextType", A);
var Xn = {
  onPlacesChanged: "places_changed"
}, ei = {
  bounds(t, e) {
    t.setBounds(e);
  }
};
class Mr extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "containerElement", ot()), m(this, "state", {
      searchBox: null
    }), m(this, "setSearchBoxCallback", () => {
      this.state.searchBox !== null && this.props.onLoad && this.props.onLoad(this.state.searchBox);
    });
  }
  componentDidMount() {
    if (re(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places), this.containerElement !== null && this.containerElement.current !== null) {
      var e = this.containerElement.current.querySelector("input");
      if (e !== null) {
        var n = new google.maps.places.SearchBox(e, this.props.options);
        this.registeredEvents = N({
          updaterMap: ei,
          eventMap: Xn,
          prevProps: {},
          nextProps: this.props,
          instance: n
        }), this.setState(function() {
          return {
            searchBox: n
          };
        }, this.setSearchBoxCallback);
      }
    }
  }
  componentDidUpdate(e) {
    this.state.searchBox !== null && (V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: ei,
      eventMap: Xn,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.searchBox
    }));
  }
  componentWillUnmount() {
    this.state.searchBox !== null && (this.props.onUnmount && this.props.onUnmount(this.state.searchBox), V(this.registeredEvents));
  }
  render() {
    return Z("div", {
      ref: this.containerElement,
      children: me.only(this.props.children)
    });
  }
}
m(Mr, "contextType", A);
var ti = {
  onPlaceChanged: "place_changed"
}, ni = {
  bounds(t, e) {
    t.setBounds(e);
  },
  restrictions(t, e) {
    t.setComponentRestrictions(e);
  },
  fields(t, e) {
    t.setFields(e);
  },
  options(t, e) {
    t.setOptions(e);
  },
  types(t, e) {
    t.setTypes(e);
  }
};
class wi extends ne {
  constructor() {
    super(...arguments), m(this, "registeredEvents", []), m(this, "containerElement", ot()), m(this, "state", {
      autocomplete: null
    }), m(this, "setAutocompleteCallback", () => {
      this.state.autocomplete !== null && this.props.onLoad && this.props.onLoad(this.state.autocomplete);
    });
  }
  componentDidMount() {
    var e;
    re(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
    var n = (e = this.containerElement.current) === null || e === void 0 ? void 0 : e.querySelector("input");
    if (n) {
      var i = new google.maps.places.Autocomplete(n, this.props.options);
      this.registeredEvents = N({
        updaterMap: ni,
        eventMap: ti,
        prevProps: {},
        nextProps: this.props,
        instance: i
      }), this.setState(() => ({
        autocomplete: i
      }), this.setAutocompleteCallback);
    }
  }
  componentDidUpdate(e) {
    V(this.registeredEvents), this.registeredEvents = N({
      updaterMap: ni,
      eventMap: ti,
      prevProps: e,
      nextProps: this.props,
      instance: this.state.autocomplete
    });
  }
  componentWillUnmount() {
    this.state.autocomplete !== null && V(this.registeredEvents);
  }
  render() {
    return Z("div", {
      ref: this.containerElement,
      className: this.props.className,
      children: me.only(this.props.children)
    });
  }
}
m(wi, "defaultProps", {
  className: ""
});
m(wi, "contextType", A);
const Ar = [
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: "#444444"
      }
    ]
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "all",
    stylers: [
      {
        visibility: "on"
      },
      {
        saturation: "-4"
      }
    ]
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [
      {
        color: "#f2f2f2"
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "all",
    stylers: [
      {
        saturation: -100
      },
      {
        lightness: 45
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "all",
    stylers: [
      {
        visibility: "simplified"
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        color: "#c5dbeb"
      },
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [
      {
        color: "#f2f2f2"
      }
    ]
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry",
    stylers: [
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.fill",
    stylers: [
      {
        visibility: "on"
      },
      {
        color: "#f2f2f2"
      }
    ]
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.stroke",
    stylers: [
      {
        visibility: "on"
      },
      {
        color: "#727272"
      }
    ]
  }
], wr = {
  "map-control": "elo-map-control"
}, zr = (t) => {
  const e = pi(), n = we(null);
  return a(() => {
    if (e && n.current) {
      const i = window.google.maps.ControlPosition[t.position];
      i && e.controls && e.controls[i] && e.controls[i].push(n.current);
    }
  }, [e, n]), /* @__PURE__ */ Z("div", { ref: n, className: wr["map-control"], children: t.children });
}, xr = "elo-desktop", pe = {
  "apartment-card": "elo-apartment-card",
  "apartment-card__image": "elo-apartment-card__image",
  "apartment-card__image-wrapper": "elo-apartment-card__image-wrapper",
  "apartment-card__tag": "elo-apartment-card__tag",
  "apartment-card__title": "elo-apartment-card__title",
  desktop: xr,
  "apartment-card__paragraph": "elo-apartment-card__paragraph",
  "apartment-card__picture-wrapper": "elo-apartment-card__picture-wrapper",
  "apartment-card__image-carousel": "elo-apartment-card__image-carousel",
  "apartment-card__logo": "elo-apartment-card__logo",
  "apartment-card__list": "elo-apartment-card__list",
  "apartment-card__button-primary": "elo-apartment-card__button-primary",
  "apartment-card__button-ghost": "elo-apartment-card__button-ghost"
}, kr = 3, Zr = rt.forwardRef(
  ({
    url: t,
    image: e,
    tagText: n,
    title: i,
    subtitle: s,
    imageClassName: r,
    className: o,
    apartmentDetails: l,
    apartmentListValues: p,
    buttonText: d,
    imageCarousel: u,
    onClick: h,
    buttonUrl: g,
    displayLogo: y = !0,
    ...c
  }, O) => {
    const [w, P] = f(!1), x = Pi("(min-width: 1024px)"), [D, b] = f([]);
    return a(() => {
      if (l) {
        const v = p.slice(0, 1);
        b(v);
      } else {
        const v = p.slice(0, kr);
        b(v);
      }
    }, [l, p]), /* @__PURE__ */ he(
      "a",
      {
        ref: O,
        href: t,
        className: Me(pe["apartment-card"], o),
        onClick: h,
        ...c,
        children: [
          /* @__PURE__ */ he("div", { className: pe["apartment-card__picture-wrapper"], children: [
            /* @__PURE__ */ Z(
              gt,
              {
                defaultSrc: e,
                alt: i,
                zoom: !0,
                className: Me(pe["apartment-card__image"], r),
                wrapperClassName: pe["apartment-card__image-wrapper"]
              }
            ),
            n ? /* @__PURE__ */ Z(ai, { className: pe["apartment-card__tag"], children: n }) : null,
            l && y && /* @__PURE__ */ Z("div", { className: pe["apartment-card__logo"], children: /* @__PURE__ */ Z(
              gt,
              {
                defaultSrc: "/Content/Vendor/icons/kodisto-logo.svg",
                alt: i,
                zoom: !0
              }
            ) }),
            l && u && (u == null ? void 0 : u.length) > 0 && /* @__PURE__ */ he(vt, { children: [
              /* @__PURE__ */ Z(
                "div",
                {
                  className: pe["apartment-card__image-carousel"],
                  onClick: (v) => {
                    v.preventDefault(), P(!0);
                  },
                  children: /* @__PURE__ */ Z(ii, { name: "Image", height: "24px", width: "24px" })
                }
              ),
              /* @__PURE__ */ Z(
                Si,
                {
                  modalAriaTitle: i + " Image Carousel",
                  modalAriaDescription: `Image carousel for ${i}`,
                  isOpen: w,
                  onClose: () => P(!1),
                  size: "lightbox",
                  children: /* @__PURE__ */ Z(Di, { images: u })
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ Z(
            fe,
            {
              type: "label",
              size: "medium",
              extraClass: pe["apartment-card__title"],
              children: i
            }
          ),
          /* @__PURE__ */ Z(
            fe,
            {
              type: "paragraph",
              size: "medium",
              extraClass: pe["apartment-card__paragraph"],
              children: s
            }
          ),
          p && p.length > 0 && /* @__PURE__ */ Z("div", { className: pe["apartment-card__list"], children: D.map((v, C) => /* @__PURE__ */ he(Oi, { children: [
            /* @__PURE__ */ he(fe, { type: "paragraph", size: "medium", children: [
              v.size,
              " m²"
            ] }),
            /* @__PURE__ */ Z(fe, { type: "paragraph", size: "medium", children: v.layout }),
            /* @__PURE__ */ Z(fe, { type: "label", size: "medium", children: v.rent })
          ] }, C)) }),
          d && /* @__PURE__ */ Z(
            Ei,
            {
              ...g && { href: g, target: "_blank" },
              variant: l ? "primary" : "ghost",
              ...l && { iconRight: "ExternalLink" },
              ...!l && { iconLeft: "Plus" },
              className: l ? pe["apartment-card__button-primary"] : pe["apartment-card__button-ghost"],
              small: !x,
              children: d
            }
          )
        ]
      }
    );
  }
);
export {
  Zr as A,
  er as C,
  Ur as G,
  Tr as I,
  zr as M,
  Rr as O,
  Br as S,
  ai as T,
  as as a,
  bs as b,
  Ws as c,
  Ar as m,
  Ki as u
};
